const CSS_STYLES = `
/* =========================================================
   CAMPAGNE URBAINE — BYOB PREMIUM TRACKER v2.2
   ========================================================= */

:root {
  --cu-bg: #fcfbf8;
  --cu-bg-soft: #f8f4ed;
  --cu-cream: #f4eee4;
  --cu-cream-2: #f7f1e8;
  --cu-line: #e6dccd;
  --cu-line-2: #ddd0bd;
  --cu-olive: #6f7d44;
  --cu-olive-dark: #5f6d39;
  --cu-olive-soft: #eef2e7;
  --cu-olive-line: #8f9f63;
  --cu-text: #3f3a34;
  --cu-text-soft: #7d7469;
  --cu-green-text: #556b46;
  --cu-kraft: #b99b73;
  --cu-shadow: rgba(106, 90, 67, 0.10);
  --cu-shadow-soft: rgba(106, 90, 67, 0.05);
  --cu-white: #ffffff;
}

/* ===== CONTENEUR GLOBAL ===== */

.byob-progress-container {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
  background: linear-gradient(to bottom, #fcfbf8 0%, #f8f4ed 100%) !important;
  border-top: 1px solid #efe7db !important;
  border-bottom: 1px solid var(--cu-line) !important;
  box-shadow: 0 4px 10px var(--cu-shadow-soft) !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: visible !important;
}

.byob-circle-step-builder-container,
.byob-circle-steps {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.byob-progress-wrapper,
.byob-timeline-wrapper {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 10px !important;
  box-sizing: border-box !important;
  position: relative !important;
}

/* ===== TIMELINE — cercles centrés, panier et coffret en absolu ===== */

.byob-circle-steps {
  position: relative !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  width: auto !important;
  min-height: 70px !important;
  padding: 2px 0 0 0 !important;
  overflow: visible !important;
  margin: 0 auto !important;
}

.byob-circle-steps::before {
  content: "" !important;
  position: absolute !important;
  left: -8px !important;
  right: -8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  height: 3px !important;
  border-radius: 999px !important;
  background: linear-gradient(
    to right,
    rgba(111,125,68,0.06) 0%,
    rgba(111,125,68,0.34) 14%,
    rgba(111,125,68,0.85) 50%,
    rgba(111,125,68,0.34) 86%,
    rgba(111,125,68,0.06) 100%
  ) !important;
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.18) inset,
    0 1px 4px rgba(111,125,68,0.16) !important;
  z-index: 0 !important;
  pointer-events: none !important;
}

.byob-circle-steps > * {
  position: relative !important;
  z-index: 1 !important;
}

.byob-circle-steps .step,
.byob-circle-steps [class*="step"],
.byob-circle-steps [class*="circle"] {
  transform: scale(0.86) !important;
  transform-origin: center !important;
  box-shadow:
    0 5px 12px rgba(105, 121, 84, 0.10),
    inset 0 1px 0 rgba(255,255,255,0.20) !important;
}

/* ===== PANIER ===== */

.byob-injected-cart {
  position: absolute !important;
  left: -70px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  cursor: pointer !important;
  width: 46px !important;
  height: 46px !important;
  border-radius: 14px !important;
  background: linear-gradient(145deg, #ffffff 0%, #f5efe6 100%) !important;
  border: 1px solid var(--cu-line) !important;
  box-shadow:
    0 4px 10px var(--cu-shadow-soft),
    inset 0 1px 0 rgba(255,255,255,0.88) !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease !important;
  z-index: 2 !important;
}

.byob-injected-cart:hover {
  transform: translateY(calc(-50% - 1px)) scale(1.03) !important;
  box-shadow:
    0 6px 12px rgba(106, 90, 67, 0.10),
    inset 0 1px 0 rgba(255,255,255,0.94) !important;
}

.byob-cart-svg {
  width: 21px !important;
  height: 21px !important;
  color: #8d8d8d !important;
}

.cart-count {
  position: absolute !important;
  top: -4px !important;
  right: -4px !important;
  width: 20px !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 999px !important;
  background: linear-gradient(145deg, #b99b73 0%, #aa895f 100%) !important;
  color: #fff !important;
  border: 2px solid #fff !important;
  box-shadow: 0 3px 8px rgba(140, 108, 74, 0.16) !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

/* ===== COFFRET ===== */

.byob-injected-gift {
  position: absolute !important;
  right: -340px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  width: 320px !important;
  height: 70px !important;
  overflow: hidden !important;
  z-index: 2 !important;
}

.byob-injected-gift img {
  width: 300px !important;
  height: 240px !important;
  object-fit: contain !important;
  transform: translateY(-80px) scale(1.10) !important;
  transform-origin: center top !important;
  filter:
    drop-shadow(0 8px 16px rgba(90, 79, 59, 0.14))
    drop-shadow(0 2px 0 rgba(255,255,255,0.30)) !important;
  transition: transform 0.22s ease !important;
}

.byob-injected-gift img:hover {
  transform: translateY(-78px) scale(1.12) !important;
}

/* ===== PHRASE DIRECTIVE ===== */

.byob-progress-message {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  margin: -4px 0 6px 0 !important;
  padding: 0 8px !important;
  background: transparent !important;
  border: none !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
  max-height: 38px !important;
  opacity: 1 !important;
  transform: translateY(0) !important;
  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    max-height 0.18s ease,
    padding 0.18s ease !important;
}

.byob-progress-message-inner {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 28px !important;
  padding: 5px 22px !important;
  border-radius: 999px !important;
  background: transparent !important;
  border: 1px solid #dccdb7 !important;
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.70),
    0 1px 3px rgba(129, 111, 84, 0.05) !important;
  color: var(--cu-green-text) !important;
  font-size: 0.92rem !important;
  font-style: italic !important;
  font-weight: 700 !important;
  letter-spacing: 0.01em !important;
  text-align: center !important;
  line-height: 1.15 !important;
  max-width: min(92vw, 780px) !important;
}

.byob-progress-container.drawer-open .byob-progress-message {
  opacity: 0 !important;
  transform: translateY(-4px) !important;
  max-height: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  pointer-events: none !important;
}

/* ===== DRAWER ===== */

.byob-cart-drawer {
  position: fixed !important;
  left: 10px !important;
  right: 10px !important;
  width: auto !important;
  max-height: 0 !important;
  z-index: 999 !important;
  overflow: visible !important;
  opacity: 0 !important;
  background: linear-gradient(to bottom, #fcfbf8 0%, #f6f1e9 100%) !important;
  border-radius: 0 0 16px 16px !important;
  border-top: none !important;
  box-shadow: none !important;
  transform: translateY(-18px) !important;
  transition:
    max-height 0.24s ease,
    opacity 0.24s ease,
    box-shadow 0.24s ease !important;
}

.byob-cart-drawer.open {
  max-height: 160px !important;
  opacity: 1 !important;
  border-top: 1px solid var(--cu-line-2) !important;
  box-shadow: 0 8px 18px rgba(98, 82, 57, 0.10) !important;
}

.drawer-header {
  display: none !important;
}

.byob-drawer-close-floating {
  position: absolute !important;
  top: 3px !important;
  right: 6px !important;
  width: 20px !important;
  height: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  border: 1px solid #ddd2c0 !important;
  background: rgba(255,255,255,0.96) !important;
  color: #978a78 !important;
  font-size: 0.72rem !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  padding: 0 !important;
  z-index: 5 !important;
  box-shadow: 0 2px 6px rgba(80,60,40,0.08) !important;
}

.byob-drawer-close-floating:hover {
  color: #5e5449 !important;
  border-color: #cdbca5 !important;
  background: #faf7f2 !important;
}

.drawer-content {
  padding: 1px 0 0 0 !important;
  overflow: hidden !important;
}

.drawer-products {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  gap: 6px !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 3px 10px 2px 10px !important;
  margin: 0 !important;
  scroll-behavior: smooth !important;
  -webkit-overflow-scrolling: touch !important;
}

.drawer-products::-webkit-scrollbar {
  height: 4px;
}

.drawer-products::-webkit-scrollbar-thumb {
  background: #d8ccb9;
  border-radius: 999px;
}

.drawer-products::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.03);
  border-radius: 999px;
}

.drawer-product-item {
  position: relative !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 7px !important;
  flex-shrink: 0 !important;
  width: 204px !important;
  min-width: 204px !important;
  max-width: 204px !important;
  padding: 5px !important;
  background: linear-gradient(180deg, #ffffff 0%, #fbf8f4 100%) !important;
  border: 1px solid #ece3d6 !important;
  border-radius: 12px !important;
  box-shadow:
    0 3px 8px rgba(120, 101, 71, 0.04),
    inset 0 1px 0 rgba(255,255,255,0.85) !important;
}

.drawer-product-image {
  width: 52px !important;
  height: 52px !important;
  flex-shrink: 0 !important;
  margin: 0 !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  background: #f6f1e8 !important;
}

.drawer-product-image img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 8px !important;
}

.drawer-product-info {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: flex-start !important;
  flex: 1 !important;
  min-width: 0 !important;
  text-align: left !important;
  padding: 0 !important;
  margin: 0 !important;
}

.drawer-product-title {
  margin: 0 0 2px 0 !important;
  font-size: 0.69rem !important;
  line-height: 1.08 !important;
  font-weight: 600 !important;
  color: var(--cu-text) !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: normal !important;
}

.drawer-product-quantity {
  margin: 0 !important;
  font-size: 0.63rem !important;
  font-weight: 700 !important;
  color: var(--cu-olive) !important;
}

.drawer-remove-btn {
  position: absolute !important;
  top: -5px !important;
  right: -5px !important;
  width: 18px !important;
  height: 18px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  border: 1px solid #ddd0be !important;
  border-radius: 50% !important;
  background: #fff !important;
  color: #9d8b76 !important;
  font-size: 8px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  box-shadow: 0 2px 5px rgba(80, 60, 40, 0.06) !important;
  z-index: 2 !important;
}

.drawer-remove-btn:hover {
  background: #fff8f6 !important;
  color: #ad4f45 !important;
  border-color: #d7aca5 !important;
}

.drawer-content > p,
.drawer-progress-msg {
  position: relative !important;
  margin: 0 8px 4px 8px !important;
  padding: 8px 14px !important;
  background: linear-gradient(180deg, #faf6ef 0%, #f2ebde 100%) !important;
  border: 1px solid #decfbb !important;
  border-radius: 10px !important;
  box-shadow:
    0 2px 5px rgba(110,92,66,0.05),
    inset 0 1px 0 rgba(255,255,255,0.90) !important;
  color: #5a6f4b !important;
  font-size: 1.5rem !important;
  font-style: italic !important;
  font-weight: 700 !important;
  text-align: center !important;
  line-height: 1.15 !important;
}

.drawer-total {
  padding: 4px 10px !important;
  border-top: 1px solid #eee4d8 !important;
  text-align: right !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #4a433a !important;
  background: #fbf8f3 !important;
}

.byob-progress-message button,
.drawer-content button {
  background: linear-gradient(145deg, var(--cu-olive) 0%, var(--cu-olive-dark) 100%) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 999px !important;
  box-shadow: 0 6px 14px rgba(94, 112, 61, 0.18) !important;
  transition: all 0.22s ease !important;
}

.byob-progress-message button:hover,
.drawer-content button:hover {
  filter: brightness(0.97) !important;
  transform: translateY(-1px) !important;
}

/* ===== BADGE +N COFFRET ===== */

.byob-injected-gift {
  position: relative !important;
}

.byob-gift-badge {
  position: absolute !important;
  bottom: 10px !important;
  right: 300px !important;
  background: linear-gradient(145deg, #b99b73 0%, #aa895f 100%) !important;
  color: #fff !important;
  font-size: 1.4rem !important;
  font-weight: 700 !important;
  padding: 8px 18px !important;
  border-radius: 999px !important;
  border: 2px solid #fff !important;
  box-shadow: 0 2px 6px rgba(140,108,74,0.20) !important;
  z-index: 5 !important;
  pointer-events: none !important;
}

@media (max-width: 1024px) {
  .byob-gift-badge {
    font-size: 1.1rem !important;
    padding: 6px 14px !important;
    bottom: 8px !important;
    right: -8px !important;
  }
}

@media (max-width: 480px) {
  .byob-gift-badge {
    font-size: 0.75rem !important;
    padding: 4px 10px !important;
    bottom: 6px !important;
    right: -4px !important;
  }
}

/* ===== NEUTRALISER BOUTON FERMER VRAI PANIER BYOB ===== */

#byob-beacon,
#hide-footer-button {
  pointer-events: none !important;
  cursor: default !important;
}

/* ===== TABLET ===== */

@media (max-width: 1200px) {
  .byob-injected-gift {
    right: -220px !important;
    width: 210px !important;
    height: 70px !important;
  }

  .byob-injected-gift img {
    width: 200px !important;
    height: 180px !important;
    transform: translateY(-68px) scale(1.08) !important;
  }

  .byob-injected-cart {
    left: -60px !important;
  }
}

@media (max-width: 1024px) {
  .byob-circle-steps {
    gap: 8px !important;
    min-height: 60px !important;
  }

  .byob-circle-steps .step,
  .byob-circle-steps [class*="step"],
  .byob-circle-steps [class*="circle"] {
    transform: scale(0.80) !important;
  }

  .byob-injected-gift {
    right: -190px !important;
    width: 180px !important;
    height: 60px !important;
  }

  .byob-injected-gift img {
    width: 170px !important;
    height: 160px !important;
    transform: translateY(-62px) scale(1.06) !important;
  }

  .byob-injected-cart {
    left: -56px !important;
    width: 40px !important;
    height: 40px !important;
  }

  .byob-progress-message-inner {
    font-size: 0.82rem !important;
  }

  .drawer-content > p,
  .drawer-progress-msg {
    font-size: 0.82rem !important;
  }
}

/* ===== MOBILE ===== */

@media (max-width: 768px) {
  .byob-progress-wrapper,
  .byob-timeline-wrapper {
    padding: 0 6px !important;
  }

  .byob-circle-steps {
    gap: 4px !important;
    min-height: 50px !important;
  }

  .byob-circle-steps::before {
    height: 2px !important;
  }

  .byob-circle-steps .step,
  .byob-circle-steps [class*="step"],
  .byob-circle-steps [class*="circle"] {
    transform: scale(0.60) !important;
  }

  .byob-injected-cart {
    left: -42px !important;
    width: 34px !important;
    height: 34px !important;
    border-radius: 11px !important;
  }

  .byob-cart-svg {
    width: 15px !important;
    height: 15px !important;
  }

  .cart-count {
    width: 16px !important;
    height: 16px !important;
    font-size: 0.60rem !important;
  }

  .byob-injected-gift {
    right: -120px !important;
    width: 112px !important;
    height: 50px !important;
  }

  .byob-injected-gift img {
    width: 106px !important;
    height: 110px !important;
    transform: translateY(-48px) scale(1.04) !important;
  }

  .byob-progress-message {
    max-height: 30px !important;
  }

  .byob-progress-message-inner {
    font-size: 0.72rem !important;
    padding: 3px 10px !important;
    max-width: calc(100vw - 18px) !important;
  }

  .byob-cart-drawer {
    left: 6px !important;
    right: 6px !important;
    transform: translateY(-14px) !important;
    overflow: visible !important;
  }

  .byob-cart-drawer.open {
    max-height: 148px !important;
  }

  .drawer-products {
    padding: 3px 6px 2px 6px !important;
  }

  .drawer-product-item {
    width: 166px !important;
    min-width: 166px !important;
    max-width: 166px !important;
    border-radius: 10px !important;
    padding: 4px !important;
  }

  .drawer-product-image {
    width: 44px !important;
    height: 44px !important;
    border-radius: 7px !important;
  }

  .drawer-product-title {
    font-size: 0.60rem !important;
  }

  .drawer-product-quantity {
    font-size: 0.55rem !important;
  }

  .drawer-remove-btn {
    width: 16px !important;
    height: 16px !important;
    font-size: 7px !important;
  }

  .drawer-content > p,
  .drawer-progress-msg {
    font-size: 0.76rem !important;
    padding: 6px 10px !important;
  }

  .drawer-total {
    font-size: 0.62rem !important;
    padding: 3px 8px !important;
  }
}

@media (min-width: 769px) {
  .byob-drawer-close-floating {
    top: -14px !important;
    right: 50% !important;
    transform: translateX(50%) !important;
    width: 28px !important;
    height: 28px !important;
    font-size: 1rem !important;
    background: #1a1a1a !important;
    color: #ffffff !important;
    border-color: #1a1a1a !important;
    z-index: 1100 !important;
  }
}

@media (max-width: 480px) {
  .byob-circle-steps {
    gap: 3px !important;
    min-height: 46px !important;
  }

  .byob-circle-steps .step,
  .byob-circle-steps [class*="step"],
  .byob-circle-steps [class*="circle"] {
    transform: scale(0.54) !important;
  }

  .byob-injected-cart {
    left: -36px !important;
    width: 30px !important;
    height: 30px !important;
  }

  .byob-cart-svg {
    width: 14px !important;
    height: 14px !important;
  }

  .byob-injected-gift {
    right: -96px !important;
    width: 88px !important;
    height: 44px !important;
  }

  .byob-injected-gift img {
    width: 82px !important;
    height: 90px !important;
    transform: translateY(-38px) scale(1.03) !important;
  }

  .byob-progress-message-inner {
    font-size: 0.64rem !important;
    padding: 2px 8px !important;
  }

  .drawer-product-item {
    width: 154px !important;
    min-width: 154px !important;
    max-width: 154px !important;
  }

  .drawer-product-image {
    width: 40px !important;
    height: 40px !important;
  }

  @media (max-width: 480px) {
    .byob-circle-steps {
      gap: 3px !important;
      min-height: 46px !important;
    }

    .byob-circle-steps .step,
    .byob-circle-steps [class*="step"],
    .byob-circle-steps [class*="circle"] {
      transform: scale(0.54) !important;
    }

    .byob-injected-cart {
      left: -36px !important;
      width: 30px !important;
      height: 30px !important;
    }

    .byob-cart-svg {
      width: 14px !important;
      height: 14px !important;
    }

    .byob-injected-gift {
      right: -96px !important;
      width: 88px !important;
      height: 44px !important;
    }

    .byob-injected-gift img {
      width: 82px !important;
      height: 90px !important;
      transform: translateY(-38px) scale(1.03) !important;
    }

    .byob-progress-message-inner {
      font-size: 0.64rem !important;
      padding: 2px 8px !important;
    }

    .drawer-product-item {
      width: 154px !important;
      min-width: 154px !important;
      max-width: 154px !important;
    }

    .drawer-product-image {
      width: 40px !important;
      height: 40px !important;
    }

    .byob-drawer-close-floating {
      top: -14px !important;
      right: 50% !important;
      transform: translateX(50%) !important;
      width: 24px !important;
      height: 24px !important;
      font-size: 0.85rem !important;
      background: #1a1a1a !important;
      color: #ffffff !important;
      border-color: #1a1a1a !important;
      z-index: 1100 !important;
    }

    .byob-cart-drawer {
      overflow: visible !important;
    }
  }
}

/* =========================================================
   LAINOHA — BYOB TRACKER V2
   STRUCTURE PRINCIPALE
========================================================= */

body .byob-progress-container.cu-byob-v2-shell {
  position: sticky !important;
  z-index: 2147481000 !important;
  width: 100% !important;
  background: #fffdf9 !important;
  border-top: 0 !important;
  border-bottom: 1px solid rgba(111, 125, 68, 0.18) !important;
  box-shadow: 0 5px 14px rgba(49, 77, 45, 0.08) !important;
  margin: 0 !important;
  padding: 7px 16px 8px !important;
  overflow: visible !important;
}

body.cu-byob-mode:not(.cu-byob-header-is-hidden)
.byob-progress-container.cu-byob-v2-shell {
  top: var(--header-height, 120px) !important;
}

body.cu-byob-mode.cu-byob-header-is-hidden
.byob-progress-container.cu-byob-v2-shell {
  top: 48px !important;
  transform: translateY(-18px) !important;
  box-shadow:
    0 -30px 0 30px #ffffff,
    0 5px 14px rgba(49, 77, 45, 0.08) !important;
}

/* =========================================================
   GRILLE V2
========================================================= */

body .cu-byob-v2-layout {
  display: grid !important;
  grid-template-columns:
    minmax(220px, 1fr)
    minmax(520px, auto)
    minmax(260px, 1fr) !important;
  align-items: center !important;
  gap: 18px !important;
  width: 100% !important;
  max-width: 1500px !important;
  margin: 0 auto !important;
}

/* =========================================================
   CENTRE — PROGRESSION V2.1
========================================================= */

body .cu-byob-v2-center {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 0 !important;
}

body .cu-byob-v2-shell .byob-circle-steps {
  position: relative !important;
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  width: min(820px, 100%) !important;
  max-width: 820px !important;
  gap: clamp(58px, 5.5vw, 105px) !important;
  min-height: 102px !important;
  margin: 0 auto !important;
  padding: 5px 18px 0 !important;
  transform: none !important;
  overflow: visible !important;
}

body .cu-byob-v2-shell .byob-circle-steps::before {
  display: none !important;
  content: none !important;
}

body .cu-byob-v2-track {
  position: absolute !important;
  left: 48px !important;
  right: 48px !important;
  top: 36px !important;
  height: 8px !important;
  --cu-progress: 0%;
  background: linear-gradient(
    90deg,
    #526034 0%,
    #7d8b58 var(--cu-progress),
    #e5ded2 var(--cu-progress),
    #e5ded2 100%
  ) !important;
  border-radius: 999px !important;
  box-shadow:
    inset 0 1px 3px rgba(90, 76, 56, 0.12),
    0 1px 0 rgba(255,255,255,0.9) !important;
  overflow: hidden !important;
  z-index: 0 !important;
  pointer-events: none !important;
}

body .cu-byob-v2-track-fill {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  width: 0%;
  background: linear-gradient(
    90deg,
    #526034 0%,
    #657547 55%,
    #7d8b58 100%
  ) !important;
  border-radius: 999px !important;
  box-shadow: 0 0 8px rgba(82, 96, 52, 0.24) !important;
  transition: width 0.45s cubic-bezier(.22,.61,.36,1) !important;
}

body .cu-byob-v2-shell .circle-step {
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  flex: 0 0 auto !important;
  min-width: 104px !important;
  margin: 0 !important;
  transform: none !important;
  z-index: 2 !important;
}

body .cu-byob-v2-shell .circle-step .circle {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 72px !important;
  height: 72px !important;
  min-width: 72px !important;
  min-height: 72px !important;
  margin: 0 !important;
  border-radius: 50% !important;
  background: #fffdf9 !important;
  border: 3px solid #9ca585 !important;
  color: #526034 !important;
  font-size: 1.35rem !important;
  font-weight: 800 !important;
  line-height: 1 !important;
  box-shadow:
    0 5px 15px rgba(49, 77, 45, 0.09),
    inset 0 1px 0 rgba(255,255,255,0.9) !important;
  transform: none !important;
  cursor: pointer !important;
  z-index: 3 !important;
}

body .cu-byob-v2-shell
.circle-step.cu-v2-current .circle {
  background: #dfe7cf !important;
  color: #314d2d !important;
  border-color: #91a06a !important;
  box-shadow:
    0 0 0 5px rgba(145, 160, 106, 0.12),
    0 7px 18px rgba(49, 77, 45, 0.14) !important;
}

body .cu-byob-v2-shell
.circle-step.cu-v2-complete .circle {
  background: linear-gradient(145deg, #526034 0%, #657345 100%) !important;
  border-color: #526034 !important;
  color: #fffaf1 !important;
  box-shadow: 0 7px 18px rgba(49, 77, 45, 0.20) !important;
}

body .cu-byob-v2-shell
.circle-step.cu-v2-missing .circle {
  background: #fffdf9 !important;
  color: #526034 !important;
  border: 3px solid #b99b73 !important;
  box-shadow:
    0 0 0 5px rgba(185, 155, 115, 0.18),
    0 6px 16px rgba(90, 72, 50, 0.12) !important;
}

body .cu-byob-v2-shell
.circle-step.cu-v2-current-out-of-order .circle {
  background: #dfe7cf !important;
  color: #314d2d !important;
  border: 3px solid #526034 !important;
  box-shadow:
    0 0 0 5px rgba(185, 155, 115, 0.18),
    0 7px 18px rgba(49, 77, 45, 0.14) !important;
}

body .cu-byob-v2-step-label {
  display: block !important;
  width: 118px !important;
  max-width: 118px !important;
  margin: 2px 0 0 !important;
  transform: translateY(-6px) !important;
  color: #48443d !important;
  font-size: 1.45rem !important;
  font-weight: 650 !important;
  line-height: 1.12 !important;
  text-align: center !important;
  white-space: normal !important;
  overflow: visible !important;
}

body .cu-byob-v2-step-meta {
  display: block !important;
  margin-top: 3px !important;
  color: #777166 !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  line-height: 1.1 !important;
  text-align: center !important;
  white-space: nowrap !important;
}

body .circle-step.cu-v2-complete
.cu-byob-v2-step-meta {
  color: #526034 !important;
}

/* =========================================================
   ÉCRAN MOYEN
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .cu-byob-v2-layout {
    grid-template-columns:
      minmax(170px, 1fr)
      minmax(430px, auto)
      minmax(190px, 1fr) !important;
    gap: 10px !important;
  }

  body .cu-byob-v2-shell .byob-circle-steps {
    width: min(650px, 100%) !important;
    gap: clamp(35px, 4vw, 60px) !important;
    min-height: 91px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  body .cu-byob-v2-track {
    left: 40px !important;
    right: 40px !important;
    top: 31px !important;
    height: 7px !important;
  }

  body .cu-byob-v2-shell .circle-step {
    min-width: 88px !important;
  }

  body .cu-byob-v2-shell .circle-step .circle {
    width: 62px !important;
    height: 62px !important;
    min-width: 62px !important;
    min-height: 62px !important;
    font-size: 1.17rem !important;
  }

  body .cu-byob-v2-step-label {
    width: 96px !important;
    max-width: 96px !important;
    margin-top: 2px !important;
    transform: translateY(-5px) !important;
    font-size: 0.76rem !important;
    font-weight: 500 !important;
  }

  body .cu-byob-v2-step-meta {
    font-size: 0.65rem !important;
  }
}

/* =========================================================
   IPHONE
========================================================= */

@media screen and (max-width: 749px) {
  body .cu-byob-v2-layout {
    grid-template-columns: 1fr 1fr !important;
    gap: 4px 6px !important;
  }

  body .cu-byob-v2-center {
    grid-column: 1 / -1 !important;
    grid-row: 1 !important;
  }

  body .cu-byob-v2-shell .byob-circle-steps {
    width: 100% !important;
    gap: 8px !important;
    min-height: 71px !important;
    padding: 8px 2px 0 !important;
  }

  body.cu-byob-mode.cu-byob-header-is-hidden
  .byob-progress-container.cu-byob-v2-shell {
    transform: translateY(-54px)!important;
  }

  body .cu-byob-v2-track {
    left: 24px !important;
    right: 24px !important;
    top: 22px !important;
    height: 5px !important;
  }

  body .cu-byob-v2-shell .circle-step {
    flex: 1 1 0 !important;
    min-width: 0 !important;
  }

  body .cu-byob-v2-shell .circle-step .circle {
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
    min-height: 44px !important;
    font-size: 0.92rem !important;
    border-width: 2px !important;
  }

  body .cu-byob-v2-step-label {
    width: 78px !important;
    max-width: 78px !important;
    margin-top: 5px !important;
    transform: translateY(-2px) !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    line-height: 1.05 !important;
  }

  body .cu-byob-v2-step-meta {
    margin-top: 2px !important;
    font-size: 0.55rem !important;
  }
}

/* =========================================================
   MESSAGE CENTRAL
========================================================= */

body .cu-byob-v2-shell .byob-progress-message {
  display: flex !important;
  width: auto !important;
  max-width: 680px !important;
  margin: 3px auto 0 !important;
  padding: 0 !important;
  max-height: none !important;
  overflow: visible !important;
  background: transparent !important;
}

body .cu-byob-v2-shell .byob-progress-message-inner {
  display: block !important;
  min-height: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  color: #526034 !important;
  font-size: 1.45rem !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  text-align: center !important;
}

/* =========================================================
   PANIER V2
========================================================= */

body .cu-byob-v2-left {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
}

body .cu-byob-v2-cart {
  appearance: none !important;
  -webkit-appearance: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  min-height: 43px !important;
  padding: 10px 16px !important;
  border: 1px solid #526034 !important;
  border-radius: 999px !important;
  background: #526034 !important;
  color: #fffaf1 !important;
  box-shadow: 0 5px 14px rgba(49, 77, 45, 0.16) !important;
  cursor: pointer !important;
}

body .cu-byob-v2-cart .byob-cart-svg {
  width: 20px !important;
  height: 20px !important;
  color: #fffaf1 !important;
  stroke: currentColor !important;
}

body .cu-byob-v2-cart-summary {
  font-size: 0.88rem !important;
  font-weight: 800 !important;
  white-space: nowrap !important;
}

body .cu-byob-v2-cart .cart-count {
  display: none !important;
}

/* =========================================================
   COFFRET LIVE V2
========================================================= */

body .cu-byob-v2-right {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
}

body .cu-byob-v2-live {
  position: relative !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 43px !important;
  padding: 10px 17px !important;
  border-radius: 999px !important;
  border: 1.5px solid #8b966a !important;
  background: #f6f2e9 !important;
  color: #526034 !important;
  font-size: 0.88rem !important;
  font-weight: 800 !important;
  box-shadow: 0 5px 14px rgba(49, 77, 45, 0.10) !important;
  cursor: pointer !important;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease !important;
}

body .cu-byob-v2-live:hover {
  transform: translateY(-1px) !important;
}

/* =========================================================
   ÉCRAN MOYEN
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .cu-byob-v2-layout {
    grid-template-columns:
      minmax(170px, 1fr)
      minmax(360px, auto)
      minmax(190px, 1fr) !important;
    gap: 10px !important;
  }

  body .cu-byob-v2-shell .byob-circle-steps {
    gap: 19px !important;
  }

  body .cu-byob-v2-shell .circle-step .circle {
    width: 47px !important;
    height: 47px !important;
    min-width: 47px !important;
    min-height: 47px !important;
    font-size: 1rem !important;
  }

  body .cu-byob-v2-shell .byob-circle-steps::before {
    top: 23px !important;
  }

  body .cu-byob-v2-step-label {
    font-size: 0.60rem !important;
    font-weight: 500 !important;
    max-width: 90px !important;
    transform: translateY(-5px) !important;
  }

  body .cu-byob-v2-cart,
  body .cu-byob-v2-live {
    padding: 9px 12px !important;
  }

  body .cu-byob-v2-cart-summary,
  body .cu-byob-v2-live {
    font-size: 0.78rem !important;
  }
}

/* =========================================================
   IPHONE
========================================================= */

@media screen and (max-width: 749px) {
  body .byob-progress-container.cu-byob-v2-shell {
    padding: 0px 7px 2px !important;
  }

  body .cu-byob-v2-shell .byob-progress-message {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  body .cu-byob-v2-shell .byob-timeline-wrapper {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  body .cu-byob-v2-layout {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 4px 6px !important;
  }

  body .cu-byob-v2-center {
    grid-column: 1 / -1 !important;
    grid-row: 1 !important;
  }

  body .cu-byob-v2-left {
    grid-column: 1 !important;
    grid-row: 2 !important;
    justify-content: flex-start !important;
  }

  body .cu-byob-v2-right {
    grid-column: 2 !important;
    grid-row: 2 !important;
    justify-content: flex-end !important;
  }

  body .cu-byob-v2-shell .byob-circle-steps {
    gap: 10px !important;
    min-height: 44px !important;
    transform: none !important;
  }

  body .cu-byob-v2-shell .circle-step .circle {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    min-height: 36px !important;
    font-size: 0.82rem !important;
    border-width: 2px !important;
  }

  body .cu-byob-v2-shell .byob-circle-steps::before {
    top: 18px !important;
    left: 18px !important;
    right: 18px !important;
    height: 3px !important;
  }

  body .cu-byob-v2-step-label {
    margin-top: 0px !important;
    transform: translateY(-2px) !important;
    max-width: 72px !important;
    font-size: 0.85rem !important;
  }

  body .cu-byob-v2-shell .byob-progress-message {
    margin-top: 2px !important;
  }

  body .cu-byob-v2-shell .byob-progress-message-inner {
    font-size: 0.68rem !important;
    line-height: 1.15 !important;
  }

  body .cu-byob-v2-cart,
  body .cu-byob-v2-live {
    width: 100% !important;
    min-height: 34px !important;
    padding: 7px 8px !important;
  }

  body .cu-byob-v2-cart-summary,
  body .cu-byob-v2-live {
    font-size: 0.67rem !important;
  }

  body .cu-byob-v2-cart .byob-cart-svg {
    width: 16px !important;
    height: 16px !important;
  }
}

/* =========================================================
   BYOB V2 — NETTOYAGE FINAL DES BLOCS AUTOUR DES CERCLES
========================================================= */

body .cu-byob-v2-shell .circle-step {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  filter: none !important;
}

body .cu-byob-v2-shell
.circle-step > *:not(.circle) {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  filter: none !important;
}

body .cu-byob-v2-shell
.circle-step::before,
body .cu-byob-v2-shell
.circle-step::after {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

/* =========================================================
   IPHONE — POSITION FINALE DES TITRES
========================================================= */

@media screen and (max-width: 749px) {
  body .cu-byob-v2-shell
  .circle-step
  .cu-byob-v2-step-label {
    position: relative !important;
    top: -8px !important;
    margin-top: 0 !important;
    margin-bottom: -10px !important;
    transform: none !important;
  }
}

/* =========================================================
   SUPPRESSION DE L'ESPACE FANTÔME
========================================================= */

body.cu-byob-mode.cu-byob-header-is-hidden
.byob-progress-container.cu-byob-v2-shell {
  margin-bottom: -22px !important;
}

@media screen and (max-width: 749px) {
  body.cu-byob-mode.cu-byob-header-is-hidden
  .byob-progress-container.cu-byob-v2-shell {
    margin-bottom: -68px !important;
  }
}

/* =========================================================
   IPHONE — MESSAGE + BOUTONS
========================================================= */

@media screen and (max-width: 749px) {
  body .cu-byob-v2-shell .byob-progress-message-inner {
    font-size: 1rem !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;
  }

  body .cu-byob-v2-shell .byob-progress-message {
    margin-top: 10px !important;
  }

  body .cu-byob-v2-left,
  body .cu-byob-v2-right {
    margin-top: 5px !important;
  }
}

/* =========================================================
   GRAND + MOYEN — MONTER LE MESSAGE CONTEXTUEL
========================================================= */

@media screen and (min-width: 1101px) {
  body .cu-byob-v2-shell .byob-progress-message {
    transform: translateY(-8px) !important;
  }
}

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .cu-byob-v2-shell .byob-progress-message {
    transform: translateY(-6px) !important;
  }
}

/* =========================================================
   LAINOHA — POPUPS CONTEXTUELS BYOB
========================================================= */

#cuByobPopupLayer {
  position: fixed !important;
  left: 50% !important;
  top: 180px;
  width: min(620px, calc(100vw - 28px)) !important;
  z-index: 2147483000 !important;
  transform: translateX(-50%) !important;
  pointer-events: none !important;
}

#cuByobPopup {
  position: relative !important;
  width: 100% !important;
  box-sizing: border-box !important;
  padding: 15px 18px 14px !important;
  border-radius: 18px !important;
  border: 1px solid rgba(111, 125, 68, 0.28) !important;
  background: linear-gradient(
    180deg,
    rgba(255, 253, 249, 0.98) 0%,
    rgba(248, 244, 237, 0.98) 100%
  ) !important;
  box-shadow:
    0 14px 34px rgba(49, 77, 45, 0.16),
    inset 0 1px 0 rgba(255,255,255,0.95) !important;
  color: #3f3a34 !important;
  opacity: 0 !important;
  visibility: hidden !important;
  transform: translateY(-10px) scale(0.985) !important;
  transition:
    opacity 0.20s ease,
    transform 0.20s ease,
    visibility 0.20s ease !important;
  pointer-events: auto !important;
}

#cuByobPopup.cu-byob-popup-visible {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translateY(0) scale(1) !important;
}

.cu-byob-popup-head {
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
}

.cu-byob-popup-icon {
  flex: 0 0 auto !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 29px !important;
  height: 29px !important;
  border-radius: 50% !important;
  background: #e6ecd9 !important;
  color: #526034 !important;
  font-size: 0.98rem !important;
  font-weight: 800 !important;
  line-height: 1 !important;
}

.cu-byob-popup-copy {
  flex: 1 1 auto !important;
  min-width: 0 !important;
}

.cu-byob-popup-title {
  margin: 0 !important;
  color: #40502e !important;
  font-size: 2rem !important;
  font-weight: 800 !important;
  line-height: 1.15 !important;
}

.cu-byob-popup-text {
  margin: 4px 0 0 !important;
  color: #514c45 !important;
  font-size: 1.75rem !important;
  font-weight: 500 !important;
  line-height: 1.32 !important;
}

.cu-byob-popup-note {
  margin: 7px 0 0 !important;
  color: #756d61 !important;
  font-size: 1.50rem !important;
  font-style: italic !important;
  font-weight: 500 !important;
  line-height: 1.25 !important;
}

.cu-byob-popup-price {
  display: inline-block !important;
  margin-top: 8px !important;
  padding: 5px 10px !important;
  border-radius: 999px !important;
  background: #eef2e7 !important;
  color: #526034 !important;
  font-size: 0.88rem !important;
  font-weight: 800 !important;
}

.cu-byob-popup-actions {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  margin-top: 12px !important;
}

.cu-byob-popup-btn {
  appearance: none !important;
  -webkit-appearance: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 36px !important;
  padding: 8px 14px !important;
  border-radius: 999px !important;
  font-family: inherit !important;
  font-size: 0.92rem !important;
  font-weight: 750 !important;
  line-height: 1 !important;
  cursor: pointer !important;
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    background 0.16s ease !important;
}

.cu-byob-popup-btn:hover {
  transform: translateY(-1px) !important;
}

.cu-byob-popup-btn-secondary {
  border: 1px solid rgba(82, 96, 52, 0.40) !important;
  background: rgba(255,255,255,0.86) !important;
  color: #526034 !important;
  box-shadow: none !important;
}

.cu-byob-popup-btn-primary {
  border: 1px solid #526034 !important;
  background: #526034 !important;
  color: #fffaf1 !important;
  box-shadow: 0 6px 14px rgba(49, 77, 45, 0.16) !important;
}

.cu-byob-popup-progress {
  position: absolute !important;
  left: 18px !important;
  right: 18px !important;
  bottom: 5px !important;
  height: 2px !important;
  overflow: hidden !important;
  border-radius: 999px !important;
  background: rgba(82, 96, 52, 0.10) !important;
}

.cu-byob-popup-progress::after {
  content: "" !important;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(82, 96, 52, 0.56) !important;
  transform-origin: left center !important;
  animation: cuByobPopupCountdown 4s linear forwards !important;
}

#cuByobPopup.cu-byob-popup-restart
.cu-byob-popup-progress::after {
  animation: none !important;
}

@keyframes cuByobPopupCountdown {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(0);
  }
}

body .cu-byob-v2-shell
.circle-step.cu-byob-popup-pulse
.circle {
  animation: cuByobNextStepPulse 1.05s ease-out 1 !important;
}

@keyframes cuByobNextStepPulse {
  0% {
    box-shadow:
      0 0 0 0 rgba(82, 96, 52, 0.30),
      0 7px 18px rgba(49, 77, 45, 0.14);
  }

  55% {
    box-shadow:
      0 0 0 9px rgba(82, 96, 52, 0.10),
      0 7px 18px rgba(49, 77, 45, 0.14);
  }

  100% {
    box-shadow:
      0 0 0 0 rgba(82, 96, 52, 0),
      0 7px 18px rgba(49, 77, 45, 0.14);
  }
}

@media screen and (max-width: 749px) {
  #cuByobPopupLayer {
    width: calc(100vw - 18px) !important;
  }

  #cuByobPopup {
    padding: 12px 12px 11px !important;
    border-radius: 15px !important;
  }

  .cu-byob-popup-head {
    gap: 8px !important;
  }

  .cu-byob-popup-icon {
    width: 25px !important;
    height: 25px !important;
    font-size: 0.82rem !important;
  }

  .cu-byob-popup-title {
    font-size: 0.91rem !important;
  }

  .cu-byob-popup-text {
    font-size: 0.80rem !important;
    line-height: 1.28 !important;
  }

  .cu-byob-popup-note {
    font-size: 0.70rem !important;
  }

  .cu-byob-popup-price {
    font-size: 0.80rem !important;
  }

  .cu-byob-popup-actions {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 7px !important;
    margin-top: 10px !important;
  }

  .cu-byob-popup-btn {
    width: 100% !important;
    min-height: 34px !important;
    padding: 7px 9px !important;
    font-size: 0.72rem !important;
  }
}




/* =========================================================
   QUICK VIEW — POPUP LAINOHA TOUJOURS AU-DESSUS
========================================================= */

body.byob-modal-open #cuByobPopupLayer {
  z-index: 2147483647 !important;
}

body.byob-modal-open #cuByobPopup {
  z-index: 2147483647 !important;
}






/* =========================================================
   LAINOHA — CORRECTIFS UX BYOB FINAUX
========================================================= */

#cuByobPopupLayer {
  position: fixed !important;
  left: 50% !important;
  width: min(800px, calc(100vw - 34px)) !important;
  transform: translateX(-50%) !important;
  z-index: 2147483000 !important;
  pointer-events: none !important;
}

#cuByobPopup {
  position: relative !important;
  width: 100% !important;
  box-sizing: border-box !important;
  padding: 22px 26px 20px !important;
  border: 1px solid rgba(111,125,68,0.28) !important;
  border-radius: 20px !important;
  background: linear-gradient(
    180deg,
    rgba(255,253,249,0.985) 0%,
    rgba(248,244,237,0.985) 100%
  ) !important;
  box-shadow:
    0 16px 38px rgba(49,77,45,0.18),
    inset 0 1px 0 rgba(255,255,255,0.96) !important;
  opacity: 0 !important;
  visibility: hidden !important;
  transform: translateY(-8px) scale(0.99) !important;
  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    visibility 0.18s ease !important;
  pointer-events: auto !important;
}

#cuByobPopup.cu-byob-popup-visible {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translateY(0) scale(1) !important;
}

.cu-byob-popup-progress {
  display: none !important;
}

#cuByobPopupClose {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
  border: 1px solid rgba(82,96,52,0.24) !important;
  border-radius: 50% !important;
  background: rgba(255,255,255,0.84) !important;
  color: #657345 !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  line-height: 1 !important;
  cursor: pointer !important;
  box-shadow: 0 2px 7px rgba(49,77,45,0.07) !important;
  z-index: 4 !important;
}

#cuByobPopupClose:hover {
  background: #ffffff !important;
  border-color: #91a06a !important;
}

.cu-byob-popup-head {
  display: flex !important;
  align-items: flex-start !important;
  gap: 12px !important;
  padding-right: 24px !important;
}

.cu-byob-popup-icon {
  flex: 0 0 auto !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 34px !important;
  height: 34px !important;
  border-radius: 50% !important;
  background: #e6ecd9 !important;
  color: #526034 !important;
  font-size: 1.05rem !important;
  font-weight: 800 !important;
}

.cu-byob-popup-copy {
  flex: 1 1 auto !important;
  min-width: 0 !important;
}

.cu-byob-popup-title {
  margin: 0 !important;
  color: #40502e !important;
  font-size: 1.35rem !important;
  font-weight: 800 !important;
  line-height: 1.16 !important;
}

.cu-byob-popup-text {
  margin: 6px 0 0 !important;
  color: #514c45 !important;
  font-size: 1.10rem !important;
  font-weight: 500 !important;
  line-height: 1.38 !important;
}

.cu-byob-popup-note {
  margin: 8px 0 0 !important;
  color: #756d61 !important;
  font-size: 1rem !important;
  font-style: italic !important;
  font-weight: 500 !important;
  line-height: 1.32 !important;
}

.cu-byob-popup-price {
  display: inline-block !important;
  margin-top: 10px !important;
  padding: 6px 12px !important;
  border-radius: 999px !important;
  background: #eef2e7 !important;
  color: #526034 !important;
  font-size: 0.95rem !important;
  font-weight: 800 !important;
}

.cu-byob-popup-actions {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  flex-wrap: wrap !important;
  gap: 9px !important;
  margin-top: 16px !important;
}

.cu-byob-popup-btn {
  appearance: none !important;
  -webkit-appearance: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 40px !important;
  padding: 9px 17px !important;
  border-radius: 999px !important;
  font-family: inherit !important;
  font-size: 0.94rem !important;
  font-weight: 750 !important;
  line-height: 1.05 !important;
  cursor: pointer !important;
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease !important;
}

.cu-byob-popup-btn:hover {
  transform: translateY(-1px) !important;
}

.cu-byob-popup-btn-secondary {
  border: 1px solid rgba(82,96,52,0.42) !important;
  background: rgba(255,255,255,0.90) !important;
  color: #526034 !important;
  box-shadow: none !important;
}

.cu-byob-popup-btn-primary {
  border: 1px solid #526034 !important;
  background: #526034 !important;
  color: #fffaf1 !important;
  box-shadow: 0 6px 14px rgba(49,77,45,0.16) !important;
}

/* =========================================================
   PANIER BYOB — NOUVEAU LOOK GRAND ÉCRAN
========================================================= */

body .byob-cart-drawer {
  background: linear-gradient(180deg, #fffdf9 0%, #f8f4ed 100%) !important;
  border: 1px solid rgba(111,125,68,0.17) !important;
  border-top: 0 !important;
  border-radius: 0 0 18px 18px !important;
  box-shadow: 0 14px 28px rgba(69,67,55,0.13) !important;
}

body .byob-cart-drawer.open {
  max-height: 245px !important;
}

body .drawer-content {
  padding: 9px 10px 8px !important;
  overflow: hidden !important;
}

body .drawer-products {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: stretch !important;
  gap: 10px !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 8px 8px 9px !important;
  scroll-behavior: smooth !important;
}

/* =========================================================
   CARTE PRODUIT PANIER — GRAND ÉCRAN
========================================================= */

body .drawer-product-item {
  position: relative !important;
  display: grid !important;
  grid-template-columns: 76px minmax(0,1fr) !important;
  align-items: center !important;
  gap: 11px !important;
  flex: 0 0 285px !important;
  width: 285px !important;
  min-width: 285px !important;
  max-width: 285px !important;
  min-height: 92px !important;
  padding: 9px 11px 9px 9px !important;
  border: 1px solid #e4d9ca !important;
  border-radius: 14px !important;
  background: linear-gradient(180deg, #ffffff 0%, #fbf7f1 100%) !important;
  box-shadow: 0 4px 11px rgba(90,76,56,0.055) !important;
}

body .drawer-product-image {
  width: 76px !important;
  height: 76px !important;
  border-radius: 10px !important;
  overflow: hidden !important;
  background: #f5efe5 !important;
}

body .drawer-product-image img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 10px !important;
}

body .drawer-product-info {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  min-width: 0 !important;
}

body .drawer-product-title {
  margin: 0 0 5px !important;
  color: #403b35 !important;
  font-size: 1.20rem !important;
  font-weight: 700 !important;
  line-height: 1.28 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
}

body .drawer-product-origin {
  margin: 0 0 3px !important;
  color: #657345 !important;
  font-size: 0.74rem !important;
  font-weight: 700 !important;
  line-height: 1.15 !important;
}

body .drawer-product-quantity {
  margin: 0 !important;
  color: #6f675d !important;
  font-size: 0.73rem !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
}

body .drawer-product-price {
  margin: 3px 0 0 !important;
  color: #526034 !important;
  font-size: 0.78rem !important;
  font-weight: 800 !important;
  line-height: 1.15 !important;
}

body .drawer-remove-btn {
  position: absolute !important;
  top: -7px !important;
  right: -7px !important;
  width: 22px !important;
  height: 22px !important;
  padding: 0 !important;
  border: 1px solid rgba(82,96,52,0.30) !important;
  border-radius: 50% !important;
  background: #ffffff !important;
  color: #657345 !important;
  font-size: 0.72rem !important;
  cursor: pointer !important;
  z-index: 3 !important;
}

body .drawer-progress-msg {
  margin: 4px 8px 6px !important;
  padding: 9px 13px !important;
  border: 1px solid rgba(111,125,68,0.20) !important;
  border-radius: 10px !important;
  background: #f8f4ed !important;
  color: #526034 !important;
  font-size: 0.92rem !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
  text-align: center !important;
}

@media screen and (min-width:750px) and (max-width:1100px) {
  body .byob-cart-drawer.open {
    max-height: 215px !important;
  }

  body .drawer-product-item {
    grid-template-columns: 62px minmax(0,1fr) !important;
    flex-basis: 235px !important;
    width: 235px !important;
    min-width: 235px !important;
    max-width: 235px !important;
    min-height: 78px !important;
    gap: 8px !important;
    padding: 7px 9px 7px 7px !important;
  }

  body .drawer-product-image {
    width: 62px !important;
    height: 62px !important;
  }

  body .drawer-product-title {
    font-size: 0.77rem !important;
  }

  body .drawer-product-origin {
    font-size: 0.66rem !important;
  }

  body .drawer-product-quantity {
    font-size: 0.65rem !important;
  }

  body .drawer-product-price {
    font-size: 0.70rem !important;
  }

  body .drawer-progress-msg {
    font-size: 0.82rem !important;
  }
}

/* =========================================================
   IPHONE — POPUP PAR-DESSUS LE TRACKER
========================================================= */

@media screen and (max-width:749px) {
  #cuByobPopupLayer {
    width: calc(100vw - 12px) !important;
  }

  #cuByobPopup {
    padding: 13px 13px 12px !important;
    border-radius: 15px !important;
    box-shadow: 0 10px 24px rgba(49,77,45,0.18) !important;
  }

  #cuByobPopupClose {
    top: 7px !important;
    right: 7px !important;
    width: 26px !important;
    height: 26px !important;
    font-size: 0.85rem !important;
  }

  .cu-byob-popup-head {
    gap: 8px !important;
    padding-right: 20px !important;
  }

  .cu-byob-popup-icon {
    width: 25px !important;
    height: 25px !important;
    font-size: 0.80rem !important;
  }

  .cu-byob-popup-title {
    font-size: 0.92rem !important;
  }

  .cu-byob-popup-text {
    font-size: 0.80rem !important;
    line-height: 1.27 !important;
  }

  .cu-byob-popup-note {
    font-size: 0.70rem !important;
  }

  .cu-byob-popup-price {
    font-size: 0.78rem !important;
  }

  .cu-byob-popup-actions {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 6px !important;
    margin-top: 10px !important;
  }

  .cu-byob-popup-btn {
    width: 100% !important;
    min-height: 34px !important;
    padding: 7px 8px !important;
    font-size: 0.70rem !important;
  }

  body .drawer-product-item {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 6px !important;
    flex: 0 0 154px !important;
    width: 154px !important;
    min-width: 154px !important;
    max-width: 154px !important;
    min-height: auto !important;
    padding: 4px !important;
  }

  body .drawer-product-image {
    width: 40px !important;
    height: 40px !important;
  }

  body .drawer-product-title {
    font-size: 0.60rem !important;
    line-height: 1.08 !important;
  }

  body .drawer-product-origin {
    font-size: 0.52rem !important;
  }

  body .drawer-product-quantity {
    font-size: 0.54rem !important;
  }

  body .drawer-product-price {
    font-size: 0.57rem !important;
  }

  body .drawer-progress-msg {
    font-size: 0.72rem !important;
  }
}

/* =========================================================
   COMMENCER LA CRÉATION
========================================================= */

.cu-byob-start-button-found {
  position: relative !important;
  display: inline-flex !important;
}

@media screen and (max-width:749px) {
  .cu-byob-start-button-found {
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* =========================================================
   BLOC 4 — FINITION CARTES PANIER
========================================================= */

body .drawer-product-collection {
  margin: 0 0 4px !important;
  color: #657345 !important;
  font-size: 0.74rem !important;
  font-weight: 700 !important;
  line-height: 1.15 !important;
}

body .drawer-product-meta {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 7px !important;
  width: 100% !important;
}

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .drawer-product-collection {
    font-size: 0.66rem !important;
  }
}

@media screen and (max-width: 749px) {
  body .drawer-product-collection {
    margin-bottom: 2px !important;
    font-size: 0.52rem !important;
  }

  body .drawer-product-meta {
    gap: 4px !important;
  }
}



/* =========================================================
   BLOC 1/4 — CARTES PRODUITS DU PANIER BYOB
========================================================= */

body .drawer-product-info {
  min-width: 0 !important;
}

body .drawer-product-collection {
  display: block !important;
  margin: 2px 0 4px !important;
  color: #657345 !important;
  font-weight: 700 !important;
  line-height: 1.18 !important;
}

body .drawer-product-collection::before {
  content: "Collection";
  display: block !important;
  margin-bottom: 2px !important;
  color: #8a8276 !important;
  font-size: 0.72em !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
}

body .drawer-product-meta {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  width: 100% !important;
}

body .drawer-product-quantity,
body .drawer-product-price {
  white-space: nowrap !important;
}

/* GRAND ÉCRAN */

@media screen and (min-width: 1101px) {
  body .drawer-product-item {
    width: 285px !important;
    min-width: 285px !important;
    max-width: 285px !important;
    min-height: 112px !important;
    grid-template-columns: 88px minmax(0, 1fr) !important;
    gap: 13px !important;
    padding: 10px 12px 10px 10px !important;
  }

  body .drawer-product-image {
    width: 88px !important;
    height: 88px !important;
    border-radius: 11px !important;
  }

  body .drawer-product-image img {
    border-radius: 11px !important;
  }

  body .drawer-product-title {
    margin: 0 0 4px !important;
    font-size: 1.35rem !important;
    font-weight: 700 !important;
    line-height: 1.18 !important;
    -webkit-line-clamp: 2 !important;
  }

  body .drawer-product-collection {
    font-size: 1.10rem !important;
    line-height: 1.15 !important;
    margin-bottom: 5px !important;
  }

  body .drawer-product-collection::before {
    font-size: 1.20rem !important;
    margin-bottom: 2px !important;
  }

  body .drawer-product-quantity {
    font-size: 1.2rem !important;
    font-weight: 700 !important;
    color: #615a51 !important;
  }

  body .drawer-product-price {
    margin: 0 !important;
    font-size: 1.20rem !important;
    font-weight: 800 !important;
    color: #526034 !important;
  }

  body .drawer-product-meta {
    gap: 9px !important;
  }
}

/* =========================================================
   ÉCRAN MOYEN
   PANIER RÉDUIT PROPORTIONNELLEMENT
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .drawer-product-item {
    width: 210px !important;
    min-width: 210px !important;
    max-width: 210px !important;
    min-height: 72px !important;
    grid-template-columns: 52px minmax(0, 1fr) !important;
    gap: 7px !important;
    padding: 7px 8px 7px 7px !important;
    border-radius: 14px !important;
  }

  body .drawer-product-image {
    width: 52px !important;
    height: 52px !important;
  }

  body .drawer-product-image img {
    border-radius: 9px !important;
  }

  body .drawer-product-title {
    font-size: 0.72rem !important;
    line-height: 1.08 !important;
    font-weight: 700 !important;
    margin: 0 0 2px !important;
    -webkit-line-clamp: 2 !important;
  }

  body .drawer-product-collection {
    font-size: 0.61rem !important;
    line-height: 1.06 !important;
    margin: 0 0 2px !important;
  }

  body .drawer-product-collection::before {
    font-size: 0.50rem !important;
    margin-bottom: 1px !important;
  }

  body .drawer-product-quantity {
    font-size: 0.60rem !important;
    line-height: 1.04 !important;
    font-weight: 700 !important;
  }

  body .drawer-product-price {
    margin: 0 !important;
    font-size: 0.64rem !important;
    line-height: 1.04 !important;
    font-weight: 800 !important;
  }

  body .drawer-product-meta {
    gap: 5px !important;
  }
}

/* IPHONE — INCHANGÉ */

@media screen and (max-width: 749px) {
  body .drawer-product-item {
    flex: 0 0 154px !important;
    width: 154px !important;
    min-width: 154px !important;
    max-width: 154px !important;
    min-height: auto !important;
    gap: 7px !important;
    padding: 5px !important;
  }

  body .drawer-product-image {
    width: 47px !important;
    height: 47px !important;
    min-width: 47px !important;
    flex: 0 0 47px !important;
  }

  body .drawer-product-title {
    margin: 0 0 2px !important;
    font-size: 0.56rem !important;
    line-height: 1.06 !important;
    font-weight: 700 !important;
    -webkit-line-clamp: 2 !important;
  }

  body .drawer-product-collection {
    margin: 0 0 2px !important;
    font-size: 0.50rem !important;
    line-height: 1.05 !important;
    font-weight: 700 !important;
  }

  body .drawer-product-collection::before {
    margin-bottom: 1px !important;
    font-size: 0.43rem !important;
  }

  body .drawer-product-quantity {
    font-size: 0.62rem !important;
    line-height: 1.05 !important;
    font-weight: 800 !important;
  }

  body .drawer-product-price {
    margin: 0 !important;
    font-size: 0.64rem !important;
    line-height: 1.05 !important;
    font-weight: 800 !important;
  }

  body .drawer-product-meta {
    gap: 5px !important;
    flex-wrap: wrap !important;
  }
}

/* =========================================================
   CORRECTIF IPHONE — CARTES PANIER BYOB
========================================================= */

@media screen and (max-width: 749px) {
  body .byob-cart-drawer .drawer-product-item {
    flex: 0 0 154px !important;
    width: 154px !important;
    min-width: 154px !important;
    max-width: 154px !important;
    gap: 8px !important;
    padding: 5px !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-image {
    width: 54px !important;
    height: 54px !important;
    min-width: 54px !important;
    min-height: 54px !important;
    flex: 0 0 54px !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-image img {
    width: 54px !important;
    height: 54px !important;
    object-fit: cover !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-title {
    font-size: 0.50rem !important;
    line-height: 1.03 !important;
    font-weight: 700 !important;
    margin: 0 0 2px !important;
    -webkit-line-clamp: 2 !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-collection {
    font-size: 0.46rem !important;
    line-height: 1.03 !important;
    margin: 0 0 3px !important;
    font-weight: 700 !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-collection::before {
    content: "Collection";
    display: block !important;
    margin-bottom: 2px !important;
    font-size: 0.58rem !important;
    line-height: 1 !important;
    font-weight: 800 !important;
    color: #657345 !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-quantity {
    font-size: 0.70rem !important;
    line-height: 1.05 !important;
    font-weight: 800 !important;
    color: #5f584f !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-price {
    font-size: 0.72rem !important;
    line-height: 1.05 !important;
    font-weight: 800 !important;
    color: #526034 !important;
    margin: 0 !important;
  }

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-meta {
    gap: 5px !important;
    align-items: center !important;
    flex-wrap: wrap !important;
  }
}

/* =========================================================
   BLOC 2/4 — BAS DU PANIER BYOB
========================================================= */

body .drawer-bottom-complete {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

body .drawer-bottom-row {
  width: 100% !important;
  box-sizing: border-box !important;
}

body .drawer-finalize-btn,
body .drawer-live-btn {
  appearance: none !important;
  -webkit-appearance: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #526034 !important;
  border-radius: 999px !important;
  font-family: inherit !important;
  font-weight: 750 !important;
  line-height: 1.12 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease !important;
}

body .drawer-finalize-btn {
  background: #526034 !important;
  color: #fffaf1 !important;
  box-shadow: 0 5px 13px rgba(49, 77, 45, 0.16) !important;
}

body .drawer-finalize-price {
  margin-left: 5px !important;
  font-weight: 800 !important;
  white-space: nowrap !important;
}

body .drawer-live-btn {
  background: #f6f2e9 !important;
  color: #526034 !important;
  border-color: #8b966a !important;
  box-shadow: 0 5px 13px rgba(49, 77, 45, 0.09) !important;
}

body .drawer-finalize-btn:hover,
body .drawer-live-btn:hover {
  transform: translateY(-1px) !important;
}

@media screen and (min-width: 1101px) {
  body .drawer-bottom-row {
    display: grid !important;
    grid-template-columns:
      minmax(260px, auto)
      minmax(360px, 1fr)
      minmax(220px, auto) !important;
    align-items: center !important;
    column-gap: 18px !important;
    padding: 5px 10px 7px !important;
  }

  body .drawer-bottom-complete
  .drawer-progress-msg {
    margin: 0 !important;
    padding: 8px 14px !important;
    min-width: 0 !important;
    border: 1px solid rgba(111,125,68,0.20) !important;
    border-radius: 10px !important;
    background: #f8f4ed !important;
    color: #526034 !important;
    font-size: 1.55rem !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: 1.22 !important;
    text-align: center !important;
  }

  body .drawer-finalize-btn,
  body .drawer-live-btn {
    min-height: 43px !important;
    padding: 9px 17px !important;
    font-size: 1.20rem !important;
  }

  body .drawer-finalize-btn {
    justify-self: start !important;
  }

  body .drawer-live-btn {
    justify-self: end !important;
  }

  body .drawer-bottom-complete
  .drawer-total {
    display: none !important;
  }
}

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .drawer-bottom-row {
    display: grid !important;
    grid-template-columns:
      minmax(205px, auto)
      minmax(230px, 1fr)
      minmax(170px, auto) !important;
    align-items: center !important;
    column-gap: 10px !important;
    padding: 4px 7px 6px !important;
  }

  body .drawer-bottom-complete
  .drawer-progress-msg {
    margin: 0 !important;
    padding: 7px 9px !important;
    min-width: 0 !important;
    border: 1px solid rgba(111,125,68,0.20) !important;
    border-radius: 9px !important;
    background: #f8f4ed !important;
    color: #526034 !important;
    font-size: 0.78rem !important;
    font-style: normal !important;
    font-weight: 650 !important;
    line-height: 1.18 !important;
    text-align: center !important;
    white-space: normal !important;
  }

  body .drawer-finalize-btn,
  body .drawer-live-btn {
    min-height: 38px !important;
    padding: 7px 10px !important;
    font-size: 0.72rem !important;
    font-weight: 750 !important;
  }

  body .drawer-finalize-btn {
    justify-self: start !important;
  }

  body .drawer-live-btn {
    justify-self: end !important;
  }

  body .drawer-finalize-price {
    margin-left: 3px !important;
  }

  body .drawer-bottom-complete
  .drawer-total {
    display: none !important;
  }
}

/* =========================================================
   BLOC 2 RÉVISÉ — TRACKER GRAND + MOYEN
========================================================= */

body .cu-byob-v2-finalize {
  appearance: none !important;
  -webkit-appearance: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #526034 !important;
  border-radius: 999px !important;
  background: #526034 !important;
  color: #fffaf1 !important;
  font-family: inherit !important;
  font-weight: 800 !important;
  line-height: 1.1 !important;
  white-space: nowrap !important;
  box-shadow: 0 5px 14px rgba(49,77,45,0.16) !important;
  cursor: pointer !important;
}

body .cu-byob-v2-finalize[hidden] {
  display: none !important;
}

/* =========================================================
   GRAND ÉCRAN — VERSION COMPACTE
========================================================= */

@media screen and (min-width: 1101px) {
  body .cu-byob-v2-layout {
    grid-template-columns:
      minmax(320px, 1fr)
      minmax(540px, 760px)
      minmax(320px, 1fr) !important;
    align-items: start !important;
    gap: 16px !important;
  }

  /*
    Boutons centrés verticalement
    sur la ligne de progression.
  */
  body .cu-byob-v2-left {
    align-self: start !important;
    justify-content: flex-start !important;
    padding-top: 6px !important;
  }

  body .cu-byob-v2-right {
    align-self: start !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 10px !important;
    padding-top: 6px !important;
  }

  /*
    Cercles légèrement plus petits.
  */
  body .cu-byob-v2-shell
  .circle-step .circle {
    width: 52px !important;
    height: 52px !important;
    min-width: 52px !important;
    min-height: 52px !important;
    font-size: 1rem !important;
  }

  /*
    Ligne conservée, simplement recentrée
    dans les nouveaux cercles.
  */
  body .cu-byob-v2-track {
    top: 26px !important;
    height: 6px !important;
  }

  body .cu-byob-v2-shell
  .byob-circle-steps {
    min-height: 68px !important;
    gap: clamp(42px, 4.1vw, 74px) !important;
  }

  /*
    Titres remontés.
  */
  body .cu-byob-v2-step-label {
    width: 100px !important;
    max-width: 100px !important;
    margin-top: -1px !important;
    transform: translateY(-8px) !important;
    font-size: 0.80rem !important;
    font-weight: 600 !important;
    line-height: 1.02 !important;
  }

  /*
    Phrase directive collée sous les titres.
  */
  body .cu-byob-v2-shell
  .byob-progress-message {
    margin-top: -12px !important;
    transform: none !important;
  }

  body .cu-byob-v2-shell
  .byob-progress-message-inner {
    font-size: 0.82rem !important;
    font-weight: 650 !important;
    line-height: 1.08 !important;
  }

  /*
    IMPORTANT :
    même quand le panier est ouvert,
    la phrase directive reste visible.
  */
  body .byob-progress-container.drawer-open
  .byob-progress-message {
    opacity: 1 !important;
    visibility: visible !important;
    max-height: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    pointer-events: auto !important;
    transform: none !important;
  }

  body .cu-byob-v2-cart,
  body .cu-byob-v2-live,
  body .cu-byob-v2-finalize {
    min-height: 40px !important;
    padding: 8px 14px !important;
    font-size: 0.82rem !important;
  }

  body .byob-cart-drawer.open {
    max-height: 132px !important;
  }

  body .drawer-content {
    padding: 5px 10px 6px !important;
  }

  body .drawer-products {
    padding: 5px 8px 6px !important;
  }
}

/* =========================================================
   ÉCRAN MOYEN — VERSION TRÈS COMPACTE
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1100px) {
  body .cu-byob-v2-layout {
    grid-template-columns:
      minmax(185px, 1fr)
      minmax(360px, 470px)
      minmax(185px, 1fr) !important;
    align-items: start !important;
    gap: 6px !important;
  }

  body .cu-byob-v2-center {
    justify-self: center !important;
    width: 100% !important;
  }

  /*
    Boutons alignés sur le centre vertical
    de la ligne de progression.
  */
  body .cu-byob-v2-left {
    align-self: start !important;
    justify-content: flex-start !important;
    padding-top: 2px !important;
  }

  body .cu-byob-v2-right {
    align-self: start !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 5px !important;
    padding-top: 2px !important;
  }

  body .cu-byob-v2-cart,
  body .cu-byob-v2-live,
  body .cu-byob-v2-finalize {
    min-height: 30px !important;
    padding: 5px 8px !important;
    font-size: 0.64rem !important;
    line-height: 1.05 !important;
  }

  body .cu-byob-v2-cart-summary {
    font-size: 0.64rem !important;
    line-height: 1.05 !important;
  }

  /*
    Cercles nettement plus petits.
  */
  body .cu-byob-v2-shell
  .circle-step .circle {
    width: 34px !important;
    height: 34px !important;
    min-width: 34px !important;
    min-height: 34px !important;
    font-size: 0.74rem !important;
    border-width: 2px !important;
  }

  /*
    On conserve la ligne,
    simplement centrée avec les cercles.
  */
  body .cu-byob-v2-track {
    top: 17px !important;
    height: 4px !important;
  }

  body .cu-byob-v2-shell
  .byob-circle-steps {
    min-height: 47px !important;
    gap: 16px !important;
    padding-top: 0 !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  body .cu-byob-v2-step-label {
    width: 68px !important;
    max-width: 68px !important;
    margin-top: -2px !important;
    transform: translateY(-8px) !important;
    font-size: 0.54rem !important;
    font-weight: 550 !important;
    line-height: 1 !important;
    text-align: center !important;
  }

  body .cu-byob-v2-shell
  .byob-progress-message {
    margin-top: -12px !important;
    transform: none !important;
  }

  body .cu-byob-v2-shell
  .byob-progress-message-inner {
    font-size: 0.66rem !important;
    font-weight: 600 !important;
    line-height: 1.04 !important;
    padding: 0 !important;
  }

  /*
    IMPORTANT :
    phrase toujours visible avec le panier ouvert.
  */
  body .byob-progress-container.drawer-open
  .byob-progress-message {
    opacity: 1 !important;
    visibility: visible !important;
    max-height: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    pointer-events: auto !important;
    transform: none !important;
  }

  /*
    Panier même largeur,
    mais nettement moins haut.
  */
  body .byob-cart-drawer.open {
    max-height: 108px !important;
  }

  body .drawer-content {
    padding: 2px 6px 3px !important;
  }

  body .drawer-products {
    padding: 3px 4px 4px !important;
    gap: 6px !important;
  }

  body .drawer-products-track {
    gap: 6px !important;
  }
}






/* =========================================================
   CORRECTIF FINAL — ÉCRAN MOYEN RÉEL
   750 À 1600 PX
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  /* =====================================================
     CERCLES PLUS PETITS
  ===================================================== */

  body .cu-byob-v2-shell
  .circle-step .circle {
    width: 34px !important;
    height: 34px !important;

    min-width: 34px !important;
    min-height: 34px !important;

    font-size: 0.74rem !important;
    border-width: 2px !important;
  }


  /* =====================================================
     LIGNE DE PROGRESSION
     même épaisseur, replacée au centre des petits cercles
  ===================================================== */

  body .cu-byob-v2-track {
    top: 17px !important;
    height: 4px !important;
  }


  /* =====================================================
     HAUTEUR DE LA ZONE DES CERCLES
  ===================================================== */

  body .cu-byob-v2-shell
  .byob-circle-steps {
    min-height: 47px !important;

    gap: 16px !important;

    padding-top: 0 !important;

    margin-left: auto !important;
    margin-right: auto !important;
  }


  /* =====================================================
     TITRES DE COLLECTION
     remontés sous les cercles
  ===================================================== */

  body .cu-byob-v2-step-label {
    width: 78px !important;
    max-width: 78px !important;

    margin-top: -2px !important;

    transform: translateY(-8px) !important;

    font-size: 0.56rem !important;
    font-weight: 550 !important;
    line-height: 1 !important;

    text-align: center !important;
  }


  /* =====================================================
     PHRASE DIRECTIVE
     collée sous les titres
  ===================================================== */

  body .cu-byob-v2-shell
  .byob-progress-message {
    margin-top: -12px !important;

    transform: none !important;
  }


  body .cu-byob-v2-shell
  .byob-progress-message-inner {
    font-size: 0.68rem !important;

    font-weight: 600 !important;

    line-height: 1.05 !important;

    padding: 0 !important;
  }


  /*
    TRÈS IMPORTANT :
    elle reste visible lorsque
    le panier BYOB est ouvert.
  */

  body .byob-progress-container.drawer-open
  .byob-progress-message {
    opacity: 1 !important;

    visibility: visible !important;

    max-height: none !important;

    padding-top: 0 !important;
    padding-bottom: 0 !important;

    pointer-events: auto !important;

    transform: none !important;
  }


  /* =====================================================
     BOUTONS SUR LA LIGNE DE PROGRESSION
  ===================================================== */

  body .cu-byob-v2-left {
    align-self: start !important;

    padding-top: 2px !important;
  }


  body .cu-byob-v2-right {
    align-self: start !important;

    padding-top: 2px !important;

    gap: 5px !important;
  }


  body .cu-byob-v2-cart,
  body .cu-byob-v2-live,
  body .cu-byob-v2-finalize {
    min-height: 30px !important;

    padding: 5px 8px !important;

    font-size: 0.64rem !important;

    line-height: 1.05 !important;
  }


  body .cu-byob-v2-cart-summary {
    font-size: 0.64rem !important;
  }


  /* =====================================================
     PANIER BYOB
     même largeur générale,
     MAIS beaucoup moins haut
  ===================================================== */

  body .byob-cart-drawer.open {
    max-height: 100px !important;
  }


  body .drawer-content {
    padding: 2px 6px 3px !important;
  }


  body .drawer-products {
    padding: 3px 4px 4px !important;

    gap: 6px !important;
  }


  /* =====================================================
     CARTES PRODUITS PLUS PETITES AU PRORATA
  ===================================================== */

  body .byob-cart-drawer
  .drawer-product-item {
    width: 210px !important;

    min-width: 210px !important;

    max-width: 210px !important;

    min-height: 68px !important;

    grid-template-columns:
      50px minmax(0, 1fr) !important;

    gap: 7px !important;

    padding: 6px 7px !important;
  }


  /* PHOTO */

  body .byob-cart-drawer
  .drawer-product-image {
    width: 50px !important;
    height: 50px !important;
  }


  /* TITRE */

  body .byob-cart-drawer
  .drawer-product-title {
    margin: 0 0 2px !important;

    font-size: 0.68rem !important;

    line-height: 1.06 !important;

    font-weight: 700 !important;
  }


  /* NOM COLLECTION */

  body .byob-cart-drawer
  .drawer-product-collection {
    margin: 0 0 2px !important;

    font-size: 0.58rem !important;

    line-height: 1.03 !important;
  }


  /* MOT COLLECTION */

  body .byob-cart-drawer
  .drawer-product-collection::before {
    margin-bottom: 1px !important;

    font-size: 0.48rem !important;
  }


  /* QUANTITÉ */

  body .byob-cart-drawer
  .drawer-product-quantity {
    font-size: 0.58rem !important;

    line-height: 1.03 !important;
  }


  /* PRIX */

  body .byob-cart-drawer
  .drawer-product-price {
    margin: 0 !important;

    font-size: 0.61rem !important;

    line-height: 1.03 !important;
  }


  body .byob-cart-drawer
  .drawer-product-meta {
    gap: 4px !important;
  }

}





/* =========================================================
   CORRECTIF FINAL — TRACKER GRAND + MOYEN
   boutons plus hauts + ligne raccourcie
   + directive plus grosse
   + panier moyen remonté
========================================================= */


/* =========================================================
   GRAND ÉCRAN
========================================================= */

@media screen and (min-width: 1101px) {

  /* Bouton panier + boutons de droite montés */
  body .cu-byob-v2-left,
  body .cu-byob-v2-right {
    padding-top: 0 !important;
    transform: translateY(-0px) !important;
  }

  /* Ligne commence au centre du 1er cercle
     et se termine au centre du dernier */
  body .cu-byob-v2-track {
    left: 120px !important;
    right: 120px !important;
  }

  /* Directive plus grosse */
  body .cu-byob-v2-shell
  .byob-progress-message-inner {
    font-size: 1.38rem !important;
    line-height: 1.10 !important;
    font-weight: 650 !important;
  }

}


/* =========================================================
   ÉCRAN MOYEN
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  /* Boutons encore un peu plus hauts */
  body .cu-byob-v2-left,
  body .cu-byob-v2-right {
    padding-top: 0 !important;
    transform: translateY(-5px) !important;
  }

  /* Enlève les bouts de ligne
     avant le 1er cercle et après le dernier */
  body .cu-byob-v2-track {
    left: 6% !important;
    right: 6% !important;
  }

  /* Directive plus grosse */
  body .cu-byob-v2-shell
  .byob-progress-message-inner {
    font-size: 1rem !important;
    line-height: 1.08 !important;
    font-weight: 650 !important;
  }

  /* Directive légèrement plus près des titres */
  body .cu-byob-v2-shell
  .byob-progress-message {
    margin-top: -13px !important;
  }

  /* Panier BYOB remonté contre la directive */
  body .byob-cart-drawer {
    transform: translateY(-1px) !important;
  }

}





/* =========================================================
   ÉCRAN MOYEN — RÉDUIRE L'ESPACE VERTICAL SOUS LA DIRECTIVE
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  /* Réduit la hauteur du grand rectangle par le bas */
  body .byob-progress-container.cu-byob-v2-shell {
    padding-bottom: 6px !important;
  }

  /* Réduit l'espace sous la phrase directive */
  body .cu-byob-v2-shell
  .byob-progress-message {
    margin-bottom: 0 !important;
  }

  /* Sécurité : aucun espace ajouté sous le centre */
  body .cu-byob-v2-center {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

}






/* =========================================================
   ÉCRAN MOYEN — SUPPRIMER LE VRAI ESPACE VIDE
   SOUS LA PHRASE DIRECTIVE
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  /* Le rectangle principal ne garde aucune hauteur inutile */
  body .byob-progress-container.cu-byob-v2-shell {
    height: auto !important;
    min-height: 0 !important;

    padding-bottom: 0 !important;
  }


  /* La grille ne doit pas étirer verticalement le tracker */
  body .cu-byob-v2-layout {
    height: auto !important;
    min-height: 0 !important;

    align-items: start !important;
    align-content: start !important;
  }


  /* Colonne centrale */
  body .cu-byob-v2-center {
    height: auto !important;
    min-height: 0 !important;

    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }


  /* Wrapper qui contient les cercles */
  body .cu-byob-v2-shell
  .byob-timeline-wrapper {
    height: auto !important;
    min-height: 0 !important;

    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }


  /* Zone réelle des cercles */
  body .cu-byob-v2-shell
  .byob-circle-steps {
    min-height: 42px !important;

    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }


  /* Phrase : aucun espace réservé dessous */
  body .cu-byob-v2-shell
  .byob-progress-message {
    height: auto !important;
    min-height: 0 !important;

    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

}








@media screen and (min-width: 1101px) {

  body .byob-cart-drawer {
    transform: translateY(-10px) !important;
  }

}






/* =========================================================
   GRAND ÉCRAN — TYPO DES BOUTONS DU TRACKER
========================================================= */

@media screen and (min-width: 1601px) {

  body .cu-byob-v2-cart,
  body .cu-byob-v2-live,
  body .cu-byob-v2-finalize {
    font-size: 1.25rem !important;
    font-weight: 800 !important;
  }

  body .cu-byob-v2-cart-summary {
    font-size: 1.25rem !important;
    font-weight: 800 !important;
  }

}


/* =========================================================
   ÉCRAN MOYEN — TYPO DES BOUTONS DU TRACKER
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  body .cu-byob-v2-cart,
  body .cu-byob-v2-live,
  body .cu-byob-v2-finalize {
    font-size: 1rem !important;
    font-weight: 800 !important;
  }

  body .cu-byob-v2-cart-summary {
    font-size: 1rem !important;
    font-weight: 800 !important;
  }

}






/* =========================================================
   GRAND ÉCRAN — NOM DES COLLECTIONS
========================================================= */

@media screen and (min-width: 1601px) {

  body .cu-byob-v2-step-label {
    font-size: 1.25rem !important;
    line-height: 1.05 !important;
  }

}


/* =========================================================
   ÉCRAN MOYEN — NOM DES COLLECTIONS
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  body .cu-byob-v2-step-label {
    font-size: 0.98rem !important;
    line-height: 1.03 !important;
  }

}









/* =========================================================
   CORRECTIF FINAL IPHONE — UX BYOB
========================================================= */

@media screen and (max-width: 749px) {

  /* =====================================================
     1. LAISSER UN PEU PLUS D'AIR SOUS LE TRACKER

     Ceci redescend légèrement le contenu situé après
     notre rectangle afin que la petite phrase +
     la flèche au-dessus de "Commencer la création"
     ne soient plus cachées.
  ===================================================== */

  body.cu-byob-mode.cu-byob-header-is-hidden
  .byob-progress-container.cu-byob-v2-shell {
    margin-bottom: -68px !important;
  }


  /* =====================================================
     2. DRAWER FERMÉ = ABSOLUMENT NON CLIQUABLE

     Très important sur Safari iPhone :
     une couche invisible ne doit pas pouvoir rester
     au-dessus de nos boutons.
  ===================================================== */

  body .byob-cart-drawer {
    pointer-events: none !important;
  }

  body .byob-cart-drawer.open {
    pointer-events: auto !important;
  }


  /* =====================================================
     3. PANIER BYOB OUVERT PLUS HAUT

     Il vient maintenant beaucoup plus près
     des noms des étapes.

     Il passera donc devant :
     - la phrase directive
     - les boutons du tracker

     Les cercles + noms d'étapes restent au-dessus.
  ===================================================== */

  body .byob-cart-drawer {
    z-index: 2147481800 !important;
    transform: translateY(-70px) !important;
  }


  body .byob-cart-drawer.open {
    max-height: 148px !important;
  }


  /* =====================================================
     4. LES 3 BOUTONS LORSQUE LE COFFRET EST COMPLET
  ===================================================== */

  body .cu-byob-v2-layout.cu-byob-v2-complete-layout {
    grid-template-columns:
      1.25fr
      2fr !important;
  }


  body .cu-byob-v2-layout.cu-byob-v2-complete-layout
  .cu-byob-v2-right {
    grid-column: 2 !important;

    display: grid !important;

    grid-template-columns:
      1.15fr
      0.85fr !important;

    gap: 4px !important;

    width: 100% !important;
  }


  /*
    Les trois boutons ont exactement
    la même hauteur.
  */

  body .cu-byob-v2-cart,
  body .cu-byob-v2-finalize,
  body .cu-byob-v2-live {
    height: 34px !important;
    min-height: 34px !important;
    max-height: 34px !important;

    padding: 5px 6px !important;

    line-height: 1 !important;

    white-space: nowrap !important;

    touch-action: manipulation !important;
    pointer-events: auto !important;

    position: relative !important;
    z-index: 3 !important;
  }


  body .cu-byob-v2-finalize,
  body .cu-byob-v2-live {
    width: 100% !important;
  }


  /*
    Coffret Live est plus court,
    donc on peut conserver une typo lisible.
  */

  body .cu-byob-v2-finalize {
    font-size: 0.64rem !important;
  }

  body .cu-byob-v2-live {
    font-size: 0.67rem !important;
  }


  /* =====================================================
     5. PANIER BYOB — TYPO PRODUITS LÉGÈREMENT AGRANDIE

     IMPORTANT :
     largeur de la carte toujours 154px.
  ===================================================== */

  body .byob-cart-drawer
  .drawer-product-item {
    width: 154px !important;
    min-width: 154px !important;
    max-width: 154px !important;
    flex-basis: 154px !important;
  }


  /* TITRE PRODUIT */

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-title {
    font-size: 0.57rem !important;
    line-height: 1.06 !important;
    font-weight: 700 !important;
  }


  /* NOM DE LA COLLECTION */

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-collection {
    font-size: 0.52rem !important;
    line-height: 1.05 !important;
  }


  /* PETIT MOT "COLLECTION" */

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-collection::before {
    font-size: 0.62rem !important;
    line-height: 1 !important;
  }


  /* QUANTITÉ */

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-quantity {
    font-size: 0.74rem !important;
    line-height: 1.05 !important;
  }


  /* PRIX */

  body .byob-cart-drawer
  .drawer-product-item
  .drawer-product-price {
    font-size: 0.76rem !important;
    line-height: 1.05 !important;
  }

}



@media screen and (max-width: 749px) {

  body .byob-cart-drawer {
    pointer-events: none !important;
  }

  body .byob-cart-drawer.open {
    pointer-events: auto !important;
  }

}








/* =========================================================
   IPHONE — STICKY UNIQUE ET PROPRE
   Peu importe l'état du header
========================================================= */

@media screen and (max-width: 749px) {

  body.cu-byob-mode
  .byob-progress-container.cu-byob-v2-shell {

    position: sticky !important;

    top: 48px !important;

    transform: none !important;

    z-index: 2147481000 !important;

    background: #fffdf9 !important;
  }

}










/* =========================================================
   LAINOHA — POPUP BYOB
   AJUSTEMENT FINAL GRAND + MOYEN ÉCRAN

   iPhone <= 749px : INCHANGÉ
========================================================= */


/* =========================================================
   ÉCRAN MOYEN
   750px à 1600px
========================================================= */

@media screen and (min-width: 750px) and (max-width: 1600px) {

  /* Conteneur extérieur :
     popup moins large qu'actuellement */
  #cuByobPopupLayer {
    width: min(
      420px,
      calc(100vw - 44px)
    ) !important;
  }
#cuByobPopupLayer {
  transform: translate(-50%, -30px) !important;
}

  /* Rectangle principal */
  #cuByobPopup {
    width: 100% !important;

    min-height: 0 !important;

    padding:
      21px 24px
      18px !important;

    border-radius:
      19px !important;
  }


  /* Ligne icône + textes */
  .cu-byob-popup-head {
    gap: 12px !important;
    padding-right: 30px !important;
  }


  /* Icône ronde */
  .cu-byob-popup-icon {
    width: 38px !important;
    height: 38px !important;

    min-width: 38px !important;
    min-height: 38px !important;

    font-size: 1rem !important;
  }


  /* Titre */
  .cu-byob-popup-title {
    margin: 0 !important;

    font-size: 1.35rem !important;
    line-height: 1.18 !important;

    font-weight: 800 !important;
  }


  /* Texte principal */
  .cu-byob-popup-text {
    margin-top: 6px !important;

    font-size: 1.08rem !important;
    line-height: 1.38 !important;

    font-weight: 500 !important;
  }


  /* Petite note */
  .cu-byob-popup-note {
    margin-top: 8px !important;

    font-size: 0.94rem !important;
    line-height: 1.32 !important;
  }


  /* Prix lorsqu'il apparaît */
  .cu-byob-popup-price {
    margin-top: 9px !important;

    padding: 6px 11px !important;

    font-size: 0.92rem !important;
  }


  /* Zone boutons */
  .cu-byob-popup-actions {
    gap: 10px !important;

    margin-top: 15px !important;
  }


  /* Boutons */
  .cu-byob-popup-btn {
  min-height: 38px !important;
  padding: 8px 15px !important;
  font-size: 0.90rem !important;
  line-height: 1.05 !important;
  font-weight: 750 !important;
}

.cu-byob-popup-actions {
  justify-content: flex-start !important;
  flex-wrap: nowrap !important;
  gap: 7px !important;
}

.cu-byob-popup-btn {
  white-space: nowrap !important;
  flex: 0 0 auto !important;
}


  /* X fermer */
  #cuByobPopupClose {
    top: 11px !important;
    right: 11px !important;

    width: 32px !important;
    height: 32px !important;

    font-size: 0.95rem !important;
  }
}


/* =========================================================
   GRAND ÉCRAN
   1601px et plus
========================================================= */

@media screen and (min-width: 1601px) {

  /* Rectangle un peu plus large qu'au portable,
     mais nettement mieux proportionné au contenu */
  #cuByobPopupLayer {
    width: min(
      700px,
      calc(100vw - 60px)
    ) !important;
  }

#cuByobPopupLayer {
  transform: translate(-50%, -50px) !important;
}


  #cuByobPopup {
    width: 100% !important;

    min-height: 0 !important;

    padding:
      22px 26px
      18px !important;

    border-radius:
      21px !important;
  }


  .cu-byob-popup-head {
    gap: 14px !important;
    padding-right: 34px !important;
  }


  /* Icône */
  .cu-byob-popup-icon {
    width: 44px !important;
    height: 44px !important;

    min-width: 44px !important;
    min-height: 44px !important;

    font-size: 1.12rem !important;
  }


  /* Titre plus présent */
  .cu-byob-popup-title {
    margin: 0 !important;

    font-size: 2.75rem !important;
    line-height: 1.17 !important;

    font-weight: 800 !important;
  }


  /* Texte principal */
  .cu-byob-popup-text {
    margin-top: 7px !important;

    font-size: 1.85rem !important;
    line-height: 1.40 !important;

    font-weight: 500 !important;
  }


  /* Note */
  .cu-byob-popup-note {
    margin-top: 9px !important;

    font-size: 1.85rem !important;
    line-height: 1.34 !important;
  }


  /* Prix */
  .cu-byob-popup-price {
    margin-top: 10px !important;

    padding: 6px 12px !important;

    font-size: 1.2rem !important;
  }


  /* Boutons */
  .cu-byob-popup-actions {
    gap: 11px !important;

    margin-top: 17px !important;
  }


  .cu-byob-popup-btn {
    min-height: 45px !important;

    padding:
      11px 20px !important;

    font-size: 1.2rem !important;
    line-height: 1.05 !important;

    font-weight: 750 !important;
  }


  /* X fermer */
  #cuByobPopupClose {
    top: 12px !important;
    right: 12px !important;

    width: 34px !important;
    height: 34px !important;

    font-size: 1rem !important;
  }
}



















`;

const styleSheet = document.createElement('style');
styleSheet.textContent = CSS_STYLES;
document.head.appendChild(styleSheet);

(function() {
  'use strict';

  const CONFIG = {
    progressImages: {
      step0: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_34_42_1.png?v=1774461719',
      step1: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_35_21_1.png?v=1774461719',
      step2: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_33_48_1.png?v=1774461718',
      step3: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_33_54_1.png?v=1774461719',
      step4: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_34_06_1.png?v=1774461718',
      step5: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_34_13_1.png?v=1774461719',
      step6: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_34_23_1.png?v=1774461718',
      step7: 'https://cdn.shopify.com/s/files/1/0636/0842/2463/files/ChatGPT_Image_21_mars_2026_16_34_30_1.png?v=1774461718'
    }
  };

  let cartState = {
    items: [],
    totalItems: 0,
    byobMessage: '',
    isComplete: false
  };

  let isUpdating = false;

  let cuSelectedStepIndex = null;
  let cuLastCoffretPopupMessage = '';
  let cuBannerStateMemory = [];

/* =========================================================
   LAINOHA — MOTEUR DE POPUPS CONTEXTUELS BYOB
========================================================= */

const POPUP_DURATION = 200000;

let popupTimer = null;
let popupPulseTimer = null;

let popupMonitorState = {
  initialized: false,
  totalItems: 0,
  requirement: null,
  cartSnapshot: [],
  bannerStates: []
};

const cuProductOriginMemory = new Map();

function getNativeCartCardKey(card) {
  if (!card) return '';

  const img =
    card.querySelector('.byob-footer-thumbnail img');

  const title =
    card.querySelector('.card-title');

  const imgSrc =
    img ? img.src : '';

  const titleText =
    title
      ? (title.title || title.textContent)
          .replace(/\s+/g, ' ')
          .trim()
      : '';

  return titleText + '||' + imgSrc;
}

function getNativeCartCardQuantity(card) {
  if (!card) return 0;

  const detail =
    card.querySelector('.byob-footer-thumbnail-detail');

  const qtyDiv =
    detail
      ? Array.from(detail.querySelectorAll('div'))
          .find(function(div) {
            return div.textContent
              .trim()
              .startsWith('x');
          })
      : null;

  return qtyDiv
    ? parseInt(
        qtyDiv.textContent
          .replace('x', '')
          .trim(),
        10
      ) || 1
    : 1;
}

function captureNativeCartSnapshot() {
  return Array.from(
    document.querySelectorAll('.byob-footer-card')
  ).map(function(card) {
    const key =
      getNativeCartCardKey(card);

    const memory =
      cuProductOriginMemory.get(key);

    return {
      key: key,

      quantity:
        getNativeCartCardQuantity(card),

      collectionName:
        card.dataset.cuCollection ||
        (memory ? memory.collectionName : ''),

      stepIndex:
        card.dataset.cuStepIndex !== undefined
          ? parseInt(card.dataset.cuStepIndex, 10)
          : (memory ? memory.stepIndex : -1)
    };
  });
}

function rememberAddedProductOrigins(
  previousSnapshot,
  currentStepIndex
) {
  const previousMap =
    new Map();

  previousSnapshot.forEach(
    function(item) {
      previousMap.set(
        item.key,
        item.quantity
      );
    }
  );

  const collectionName =
    getV2StepName(currentStepIndex);

  document
    .querySelectorAll('.byob-footer-card')
    .forEach(function(card) {
      const key =
        getNativeCartCardKey(card);

      const newQuantity =
        getNativeCartCardQuantity(card);

      const oldQuantity =
        previousMap.get(key) || 0;

      if (newQuantity > oldQuantity) {
        cuProductOriginMemory.set(
          key,
          {
            stepIndex: currentStepIndex,
            collectionName: collectionName
          }
        );
      }
    });

  applyKnownProductOrigins();
}

function applyKnownProductOrigins() {
  document
    .querySelectorAll('.byob-footer-card')
    .forEach(function(card) {
      const key =
        getNativeCartCardKey(card);

      const memory =
        cuProductOriginMemory.get(key);

      if (!memory) return;

      card.dataset.cuCollection =
        memory.collectionName || '';

      card.dataset.cuStepIndex =
        String(memory.stepIndex);
    });
}

function findCartChangeContext(
  previousSnapshot,
  currentSnapshot,
  delta
) {
  const previousMap =
    new Map(
      previousSnapshot.map(
        function(item) {
          return [item.key, item];
        }
      )
    );

  const currentMap =
    new Map(
      currentSnapshot.map(
        function(item) {
          return [item.key, item];
        }
      )
    );

  if (delta > 0) {
    for (const item of currentSnapshot) {
      const previous =
        previousMap.get(item.key);

      const previousQty =
        previous
          ? previous.quantity
          : 0;

      if (item.quantity > previousQty) {
        return item;
      }
    }
  }

  if (delta < 0) {
    for (const item of previousSnapshot) {
      const current =
        currentMap.get(item.key);

      const currentQty =
        current
          ? current.quantity
          : 0;

      if (currentQty < item.quantity) {
        return item;
      }
    }
  }

  return null;
}


function syncBannerStateMemoryFromCartSnapshot(
  snapshot
) {
  if (!Array.isArray(snapshot)) {
    return;
  }

  const selectedByStep = {};

  snapshot.forEach(function(item) {
    if (
      !Number.isInteger(item.stepIndex) ||
      item.stepIndex < 1
    ) {
      return;
    }

    if (
      selectedByStep[
        item.stepIndex
      ] === undefined
    ) {
      selectedByStep[
        item.stepIndex
      ] = 0;
    }

    selectedByStep[
      item.stepIndex
    ] +=
      item.quantity || 0;
  });

  const steps =
    getV2Steps();

  steps.forEach(
    function(step, stepIndex) {

      if (stepIndex === 0) {
        return;
      }

      const oldState =
        cuBannerStateMemory[
          stepIndex
        ];

      if (!oldState) {
        return;
      }

      const selected =
        selectedByStep[
          stepIndex
        ] || 0;

      const minimum =
        oldState.minimum || 0;

      const remaining =
        Math.max(
          minimum - selected,
          0
        );

      cuBannerStateMemory[
        stepIndex
      ] = {
        exists: true,
        selected: selected,
        minimum: minimum,
        remaining: remaining,
        isSatisfied:
          minimum > 0
            ? selected >= minimum
            : false
      };
    }
  );
}




function captureAllBannerStates() {
  const states = [];
  const steps = getV2Steps();

  steps.forEach(
    function(step, index) {
      states[index] =
        getBannerStateForStep(index);
    }
  );

  return states;
}

function getNativeBYOBMessage() {
  const el =
    document.querySelector('#btn-add-to-cart span') ||
    document.querySelector('.btn-add-to-cart span');

  return el
    ? el.textContent
        .replace(/\s+/g, ' ')
        .trim()
    : '';
}

function getBYOBTotalItems() {
  let total = 0;

  const cards =
    document.querySelectorAll('.byob-footer-card');

  if (cards.length) {
    cards.forEach(function(card) {
      const detail =
        card.querySelector('.byob-footer-thumbnail-detail');

      const qtyDiv =
        detail
          ? Array.from(detail.querySelectorAll('div'))
              .find(function(d) {
                return d.textContent
                  .trim()
                  .startsWith('x');
              })
          : null;

      const qty =
        qtyDiv
          ? parseInt(
              qtyDiv.textContent
                .trim()
                .replace('x', '')
                .trim(),
              10
            ) || 1
          : 1;

      total += qty;
    });

    return total;
  }

  document
    .querySelectorAll('.byob-footer-thumbnail-detail div')
    .forEach(function(d) {
      const value =
        d.textContent.trim();

      if (value.startsWith('x')) {
        total +=
          parseInt(
            value
              .replace('x', '')
              .trim(),
            10
          ) || 0;
      }
    });

  return total;
}

function parseRemainingRequired(message) {
  if (!message) return null;

  const normalized =
    message.toLowerCase();

  const match =
    normalized.match(/ajouter\s+(\d+)/);

  if (!match) return null;

  return parseInt(match[1], 10);
}

function parseRequiredStepNumber(message) {
  if (!message) return null;

  const normalized =
    message.toLowerCase();

  const stepMatch =
    normalized.match(/[ée]tape\s*(\d+)/);

  if (stepMatch) {
    return parseInt(stepMatch[1], 10);
  }

  if (
    normalized.includes('byob') &&
    normalized.includes('tous les produits')
  ) {
    return 2;
  }

  if (normalized.includes('type de coffret')) {
    return 1;
  }

  return null;
}

function messageRequestsCard(message) {
  const normalized =
    (message || '').toLowerCase();

  return (
    normalized.includes('carte de souhait') ||
    normalized.includes('cartes de souhait') ||
    normalized.includes('carte de souhaits') ||
    normalized.includes('cartes de souhaits')
  );
}

function buildRequirementState() {
  const raw =
    getNativeBYOBMessage();

  const translated =
    translateBYOBMessage();

  const isComplete =
    translated === 'COMPLETE';

  const remaining =
    isComplete
      ? 0
      : parseRemainingRequired(raw);

  const requiredStepNumber =
    isComplete
      ? null
      : parseRequiredStepNumber(raw);

  const isCard =
    !isComplete &&
    messageRequestsCard(raw);

  let stageKey = 'UNKNOWN';

  if (isComplete) {
    stageKey = 'COMPLETE';
  } else if (isCard) {
    stageKey = 'CARD';
  } else if (requiredStepNumber) {
    stageKey =
      'STEP-' + requiredStepNumber;
  } else if (raw) {
    stageKey =
      raw
        .toLowerCase()
        .replace(/\d+/g, '#')
        .replace(/\s+/g, ' ')
        .trim();
  }

  return {
    raw: raw,
    translated: translated,
    isComplete: isComplete,
    remaining: remaining,
    requiredStepNumber: requiredStepNumber,
    isCard: isCard,
    stageKey: stageKey
  };
}

function getCurrentV2StepIndex() {
  const steps =
    getV2Steps();

  if (!steps.length) {
    return -1;
  }

  const nativeCurrent =
    steps.findIndex(function(step) {
      return nativeStepLooksCurrent(step);
    });

  if (nativeCurrent >= 0) {
    return nativeCurrent;
  }

  const customCurrent =
    steps.findIndex(function(step) {
      return (
        step.classList.contains('cu-v2-current') ||
        step.classList.contains('cu-v2-current-out-of-order')
      );
    });

  return customCurrent;
}

function getCardStepIndex() {
  const steps =
    getV2Steps();

  return steps.findIndex(
    function(step) {
      const label =
        step.querySelector('.cu-byob-v2-step-label');

      const nativeTitle =
        step.querySelector('.circle-step-title');

      const text =
        (
          (label ? label.textContent : '') +
          ' ' +
          (nativeTitle ? nativeTitle.textContent : '')
        ).toLowerCase();

      return (
        text.includes('carte') ||
        text.includes('souhait')
      );
    }
  );
}

function getFirstIncompleteStepIndex() {
  const steps =
    getV2Steps();

  if (!steps.length) {
    return -1;
  }

  for (let i = 0; i < steps.length; i++) {
    if (!nativeStepLooksComplete(steps[i])) {
      return i;
    }
  }

  return -1;
}

function getRecommendedStepIndex(requirement) {
  const steps =
    getV2Steps();

  if (!steps.length) {
    return -1;
  }

  if (
    requirement &&
    requirement.requiredStepNumber
  ) {
    const index =
      requirement.requiredStepNumber - 1;

    if (
      index >= 0 &&
      index < steps.length
    ) {
      return index;
    }
  }

  if (
    requirement &&
    requirement.isCard
  ) {
    const cardIndex =
      getCardStepIndex();

    if (cardIndex >= 0) {
      return cardIndex;
    }
  }

  return getFirstIncompleteStepIndex();
}

/* =========================================================
   LAINOHA — PRIX RÉELS DES PRODUITS BYOB
========================================================= */

function normalizeBYOBProductText(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/[«»"'’]/g, '')
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ')
    .trim();
}

function parseBYOBPriceValue(text) {
  const clean =
    String(text || '')
      .replace(/\s+/g, ' ')
      .replace(/cad/ig, '')
      .replace(/\$/g, '')
      .replace(',', '.')
      .trim();

  const match =
    clean.match(/(\d+(?:\.\d{1,2})?)/);

  return match
    ? parseFloat(match[1])
    : 0;
}

function formatBYOBPrice(value) {
  const amount =
    Number(value || 0);

  return amount
    .toFixed(2)
    .replace('.', ',') +
    ' $ CA';
}

/* =========================================================
   LAINOHA — MÉMOIRE PRIX
   UNIQUEMENT POUR "TOUS LES PRODUITS"

   PROBLÈME :
   - L'univers Tous les produits possède des filtres spéciaux.
   - Lors de leur activation, plusieurs centaines de produits
     sont chargés progressivement.
   - Si la cliente quitte cet univers puis revient,
     les filtres ne sont plus actifs.
   - Le Tracker peut alors perdre les références de prix
     apprises pendant le chargement des filtres.

   SOLUTION :
   - Le catalogue reste cumulatif.
   - Les prix appris dans "Tous les produits" sont également
     conservés dans sessionStorage.
   - Au retour dans CET univers seulement, ils sont restaurés.
   - Les autres univers BYOB ne sont pas concernés.

   IMPORTANT :
   Aucun message Tracker / Popup / règle d'étape n'est modifié.
========================================================= */

let cuByobPriceCatalog = null;

const CU_BYOB_ALL_PRODUCTS_PRICE_CACHE =
  'lainoha_byob_all_products_prices_v1';


function isBYOBAllProductsUniverse() {

  if (
    typeof buildrules === 'undefined' ||
    !Array.isArray(buildrules)
  ) {
    return false;
  }

  return buildrules.some(function(rule) {

    const text =
      String(
        rule?.title ||
        rule?.handle ||
        ''
      )
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();

    return (
      text.includes('tous les produits')
    );

  });
}


function restoreBYOBAllProductsPrices(catalog) {

  if (!catalog) {
    return;
  }

  try {

    const raw =
      sessionStorage.getItem(
        CU_BYOB_ALL_PRODUCTS_PRICE_CACHE
      );

    if (!raw) {
      return;
    }

    const saved =
      JSON.parse(raw);

    if (
      !saved ||
      !Array.isArray(saved.products)
    ) {
      return;
    }

    saved.products.forEach(
      function(product) {

        if (
          !product ||
          !product.key
        ) {
          return;
        }

        if (
          !catalog.products.has(
            product.key
          )
        ) {
          catalog.products.set(
            product.key,
            product
          );
        }

        const productInfo =
          catalog.products.get(
            product.key
          );

        (
          Array.isArray(
            productInfo.variants
          )
            ? productInfo.variants
            : []
        ).forEach(
          function(variant) {

            if (variant.nameKey) {
              catalog.variants.set(
                variant.nameKey,
                variant
              );
            }

            if (
              variant.fullVariantKey
            ) {
              catalog.variants.set(
                variant.fullVariantKey,
                variant
              );
            }

          }
        );

      }
    );

    console.log(
      '💾 Prix Tous les produits restaurés :',
      catalog.products.size,
      'produits connus'
    );

  } catch (error) {

    console.warn(
      '⚠️ Impossible de restaurer les prix Tous les produits',
      error
    );

  }
}


function saveBYOBAllProductsPrices(
  catalog
) {

  if (
    !catalog ||
    typeof buildrules === 'undefined' ||
    !Array.isArray(buildrules)
  ) {
    return;
  }

  try {

    /*
      On sauvegarde UNIQUEMENT les produits
      appartenant à la règle "Tous les produits".
    */

    const allowedKeys =
      new Set();

    buildrules.forEach(
      function(rule) {

        const ruleText =
          String(
            rule?.title ||
            rule?.handle ||
            ''
          )
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();

        if (
          !ruleText.includes(
            'tous les produits'
          )
        ) {
          return;
        }

        const products =
          Array.isArray(
            rule.json_products
          )
            ? rule.json_products
            : [];

        products.forEach(
          function(product) {

            const key =
              normalizeBYOBProductText(
                product?.title
              );

            if (key) {
              allowedKeys.add(key);
            }

          }
        );

      }
    );


    /*
      On fusionne aussi ce qui avait déjà
      été mémorisé lors d'un précédent chargement.
    */

    const oldRaw =
      sessionStorage.getItem(
        CU_BYOB_ALL_PRODUCTS_PRICE_CACHE
      );

    const oldProducts =
      oldRaw
        ? (
            JSON.parse(oldRaw)
              ?.products || []
          )
        : [];

    const savedMap =
      new Map();

    oldProducts.forEach(
      function(product) {

        if (
          product &&
          product.key
        ) {
          savedMap.set(
            product.key,
            product
          );
        }

      }
    );


    allowedKeys.forEach(
      function(key) {

        const product =
          catalog.products.get(key);

        if (product) {
          savedMap.set(
            key,
            product
          );
        }

      }
    );


    sessionStorage.setItem(
      CU_BYOB_ALL_PRODUCTS_PRICE_CACHE,
      JSON.stringify({
        products:
          Array.from(
            savedMap.values()
          )
      })
    );

  } catch (error) {

    console.warn(
      '⚠️ Impossible de mémoriser les prix Tous les produits',
      error
    );

  }
}


function getBYOBPriceCatalog() {

  /*
    Catalogue principal du Tracker.
  */

  if (!cuByobPriceCatalog) {

    cuByobPriceCatalog = {
      products: new Map(),
      variants: new Map()
    };

    /*
      TRÈS IMPORTANT :
      on restaure la mémoire persistante
      seulement dans l'univers
      "Tous les produits".
    */

    if (
      isBYOBAllProductsUniverse()
    ) {
      restoreBYOBAllProductsPrices(
        cuByobPriceCatalog
      );
    }
  }


  const catalog =
    cuByobPriceCatalog;


  if (
    typeof buildrules === 'undefined' ||
    !Array.isArray(buildrules)
  ) {
    return catalog;
  }


  let changed = false;


  buildrules.forEach(
    function(rule) {

      const products =
        Array.isArray(
          rule.json_products
        )
          ? rule.json_products
          : [];


      products.forEach(
        function(product) {

          if (!product) {
            return;
          }


          const productTitle =
            normalizeBYOBProductText(
              product.title
            );


          if (!productTitle) {
            return;
          }


          const variants =
            Array.isArray(
              product.variants
            )
              ? product.variants
              : [];


          let productInfo =
            catalog.products.get(
              productTitle
            );


          if (!productInfo) {

            productInfo = {
              title:
                product.title || '',
              key:
                productTitle,
              variants: []
            };


            catalog.products.set(
              productTitle,
              productInfo
            );


            changed = true;
          }


          variants.forEach(
            function(variant) {

              if (!variant) {
                return;
              }


              const cents =
                Number(
                  variant.price
                );


              if (
                !Number.isFinite(
                  cents
                )
              ) {
                return;
              }


              const price =
                cents / 100;


              const variantTitle =
                normalizeBYOBProductText(
                  variant.title
                );


              const variantName =
                normalizeBYOBProductText(
                  variant.name
                );


              const fullVariantKey =
                (
                  variantTitle &&
                  variantTitle !==
                    'default title'
                )
                  ? normalizeBYOBProductText(
                      product.title +
                      ' ' +
                      variant.title
                    )
                  : '';


              let variantInfo =
                productInfo.variants.find(
                  function(existing) {

                    return (
                      existing.titleKey ===
                        variantTitle &&
                      existing.nameKey ===
                        variantName &&
                      existing.price ===
                        price
                    );

                  }
                );


              if (!variantInfo) {

                variantInfo = {
                  title:
                    variant.title || '',
                  name:
                    variant.name || '',
                  titleKey:
                    variantTitle,
                  nameKey:
                    variantName,
                  fullVariantKey:
                    fullVariantKey,
                  price:
                    price
                };


                productInfo.variants.push(
                  variantInfo
                );


                changed = true;
              }


              if (variantName) {

                catalog.variants.set(
                  variantName,
                  variantInfo
                );

              }


              if (fullVariantKey) {

                catalog.variants.set(
                  fullVariantKey,
                  variantInfo
                );

              }

            }
          );

        }
      );

    }
  );


  /*
    On sauvegarde seulement si :
    1. nous sommes dans Tous les produits;
    2. le catalogue vient d'apprendre quelque chose.
  */

  if (
    changed &&
    isBYOBAllProductsUniverse()
  ) {

    saveBYOBAllProductsPrices(
      catalog
    );

  }


  return catalog;
}

function getBYOBProductPriceByTitle(productTitle) {
  const wanted =
    normalizeBYOBProductText(productTitle);

  if (!wanted) {
    return 0;
  }

  const catalog =
    getBYOBPriceCatalog();

  const directVariant =
    catalog.variants.get(wanted);

  if (directVariant) {
    return directVariant.price;
  }

  const product =
    catalog.products.get(wanted);

  if (!product) {
    return 0;
  }

  if (!product.variants.length) {
    return 0;
  }

  if (product.variants.length === 1) {
    return product.variants[0].price;
  }

  const prices =
    Array.from(
      new Set(
        product.variants.map(
          function(variant) {
            return variant.price;
          }
        )
      )
    );

  if (prices.length === 1) {
    return prices[0];
  }

  return 0;
}

function getBYOBFooterCardPrice(card) {
  if (!card) {
    return 0;
  }

  const titleElement =
    card.querySelector('.card-title');

  if (!titleElement) {
    return 0;
  }

  const title =
    (
      titleElement.title ||
      titleElement.textContent ||
      ''
    )
      .replace(/\s+/g, ' ')
      .trim();

  const normalizedTitle =
    normalizeBYOBProductText(title);

  const catalog =
    getBYOBPriceCatalog();

  const directVariant =
    catalog.variants.get(normalizedTitle);

  if (directVariant) {
    return directVariant.price;
  }

  const product =
    catalog.products.get(normalizedTitle);

  if (!product) {
    return getBYOBProductPriceByTitle(title);
  }

  if (product.variants.length === 1) {
    return product.variants[0].price;
  }

  const cardText =
    normalizeBYOBProductText(
      card.textContent
    );

  for (const variant of product.variants) {
    if (
      variant.titleKey &&
      variant.titleKey !== 'default title' &&
      cardText.includes(variant.titleKey)
    ) {
      return variant.price;
    }

    if (
      variant.nameKey &&
      cardText.includes(variant.nameKey)
    ) {
      return variant.price;
    }
  }

  const prices =
    Array.from(
      new Set(
        product.variants.map(
          function(variant) {
            return variant.price;
          }
        )
      )
    );

  if (prices.length === 1) {
    return prices[0];
  }

  return 0;
}

function calculateBYOBRealTotal() {
  let total = 0;

  document
    .querySelectorAll('.byob-footer-card')
    .forEach(function(card) {
      const price =
        getBYOBFooterCardPrice(card);

      const quantity =
        getNativeCartCardQuantity(card) || 1;

      total += price * quantity;
    });

  return total;
}

function getCurrentBYOBPrice() {
  const total =
    calculateBYOBRealTotal();

  if (
    !Number.isFinite(total) ||
    total <= 0
  ) {
    return '';
  }

  return formatBYOBPrice(total);
}

/* =========================================================
   LAINOHA — POPUP V2 FINAL
========================================================= */

function getV2StepName(stepIndex) {
  const steps =
    getV2Steps();

  if (
    stepIndex < 0 ||
    stepIndex >= steps.length
  ) {
    return '';
  }

  const label =
    steps[stepIndex].querySelector(
      '.cu-byob-v2-step-label'
    );

  if (label) {
    return label.textContent
      .replace(/\s+/g, ' ')
      .trim();
  }

  return 'Étape ' + (stepIndex + 1);
}

function getBannerStateForStep(stepIndex) {
  const stepNumber =
    stepIndex + 1;

  const banner =
    document.querySelector(
      '.cu-byob-rule-banner[data-step="' +
      stepNumber +
      '"]'
    );

  if (!banner) {

  if (
    cuBannerStateMemory[
      stepIndex
    ]
  ) {
    return {
      ...cuBannerStateMemory[
        stepIndex
      ]
    };
  }

  return {
    exists: false,
    selected: 0,
    minimum: 0,
    remaining: 0,
    isSatisfied: false
  };
}

  let minimum =
    parseInt(
      banner.dataset.min || '0',
      10
    ) || 0;

  const countEl =
    banner.querySelector('.cu-rule-count');

  const countText =
    countEl
      ? countEl.textContent
          .replace(/\s+/g, ' ')
          .trim()
      : '';

  const selectedMatch =
    countText.match(/(\d+)/);

  const selected =
    selectedMatch
      ? parseInt(selectedMatch[1], 10) || 0
      : 0;

  if (!minimum) {
    const minimumMatch =
      countText.match(/minimum\s+(\d+)/i);

    if (minimumMatch) {
      minimum =
        parseInt(
          minimumMatch[1],
          10
        ) || 0;
    }
  }

  const remaining =
    Math.max(
      minimum - selected,
      0
    );

  const state = {
  exists: true,
  selected: selected,
  minimum: minimum,
  remaining: remaining,
  isSatisfied:
    minimum > 0
      ? selected >= minimum
      : false
};

cuBannerStateMemory[
  stepIndex
] = {
  ...state
};

return state;
}



















/* =========================================================
   LAINOHA — VALIDATION RÉELLE DES EXIGENCES BYOB

   CEINTURE DE SÉCURITÉ INDÉPENDANTE

   OBJECTIF :
   - Ne jamais considérer une étape complète uniquement
     parce qu'une ancienne mémoire dit "isSatisfied = true".
   - Recompter les produits réellement présents dans
     le panier BYOB actuel.
   - Utiliser leur stepIndex mémorisé.
   - Lorsque la vraie bannière de l'étape est présente,
     exiger également que cette bannière confirme le minimum.
   - Ne PAS remplacer la logique BYOB existante.
========================================================= */

function validateRealBYOBRequirements() {

  const steps =
    getV2Steps();

  if (!steps.length) {
    return {
      isValid: false,
      firstInvalidStepIndex: 0,
      missingCount: 1,
      stepName: 'Coffret',
      byStep: []
    };
  }


  /*
    On remet d'abord sur les cartes du panier
    toutes les origines déjà connues.
  */

  applyKnownProductOrigins();


  /*
    Snapshot du VRAI panier BYOB actuel.
  */

  const snapshot =
    captureNativeCartSnapshot();


  /*
    Quantité réellement présente par étape.
  */

  const selectedByStep = {};

  snapshot.forEach(
    function(item) {

      if (
        !Number.isInteger(
          item.stepIndex
        ) ||
        item.stepIndex < 0
      ) {
        return;
      }

      if (
        selectedByStep[
          item.stepIndex
        ] === undefined
      ) {
        selectedByStep[
          item.stepIndex
        ] = 0;
      }

      selectedByStep[
        item.stepIndex
      ] +=
        Number(
          item.quantity || 0
        );
    }
  );


  const byStep = [];

  let firstInvalidStepIndex =
    -1;

  let firstMissingCount =
    0;


  steps.forEach(
    function(step, stepIndex) {

      /* ===================================================
         ÉTAPE 1 — TYPE DE COFFRET

         Cette étape ne repose pas sur cuBannerStateMemory.
      =================================================== */

      if (stepIndex === 0) {

        const isSatisfied =
          nativeStepLooksComplete(
            step
          );

        byStep[
          stepIndex
        ] = {
          stepIndex:
            stepIndex,

          stepName:
            getV2StepName(
              stepIndex
            ),

          selected:
            isSatisfied
              ? 1
              : 0,

          minimum:
            1,

          missing:
            isSatisfied
              ? 0
              : 1,

          hasKnownMinimum:
            true,

          isSatisfied:
            isSatisfied,

          source:
            'native-coffret'
        };


        if (
          !isSatisfied &&
          firstInvalidStepIndex < 0
        ) {
          firstInvalidStepIndex =
            stepIndex;

          firstMissingCount =
            1;
        }

        return;
      }


      /* ===================================================
         AUTRES ÉTAPES

         On prend le minimum connu, mais on ne fait PAS
         confiance à son ancien selected/isSatisfied.
      =================================================== */

      const bannerState =
        getBannerStateForStep(
          stepIndex
        );


      const minimum =
        Number(
          bannerState &&
          bannerState.minimum
            ? bannerState.minimum
            : 0
        );


      const selectedFromCart =
        Number(
          selectedByStep[
            stepIndex
          ] || 0
        );


      /*
        Vérifie si la VRAIE bannière de cette étape
        est actuellement présente dans le DOM.

        Si oui, c'est une deuxième confirmation
        indépendante de la mémoire.
      */

      const liveBanner =
        document.querySelector(
          '.cu-byob-rule-banner[data-step="' +
          (stepIndex + 1) +
          '"]'
        );


      let liveSelected =
        null;


      if (liveBanner) {

        const countEl =
          liveBanner.querySelector(
            '.cu-rule-count'
          );

        const countText =
          countEl
            ? countEl.textContent
                .replace(
                  /\s+/g,
                  ' '
                )
                .trim()
            : '';


        const selectedMatch =
          countText.match(
            /(\d+)/
          );


        if (selectedMatch) {
          liveSelected =
            parseInt(
              selectedMatch[1],
              10
            ) || 0;
        }
      }


      /*
        Si le minimum est connu :
        le vrai panier doit respecter le minimum.

        ET, lorsqu'une vraie bannière est disponible,
        elle doit elle aussi confirmer le minimum.
      */

      if (minimum > 0) {

        const cartSatisfied =
          selectedFromCart >=
          minimum;


        const liveBannerSatisfied =
          liveSelected === null
            ? true
            : liveSelected >= minimum;


        const isSatisfied =
          cartSatisfied &&
          liveBannerSatisfied;


        const effectiveSelected =
          liveSelected === null
            ? selectedFromCart
            : Math.min(
                selectedFromCart,
                liveSelected
              );


        const missing =
          Math.max(
            minimum -
            effectiveSelected,
            0
          );


        byStep[
          stepIndex
        ] = {
          stepIndex:
            stepIndex,

          stepName:
            getV2StepName(
              stepIndex
            ),

          selected:
            effectiveSelected,

          selectedFromCart:
            selectedFromCart,

          selectedFromBanner:
            liveSelected,

          minimum:
            minimum,

          missing:
            missing,

          hasKnownMinimum:
            true,

          isSatisfied:
            isSatisfied,

          source:
            liveSelected === null
              ? 'cart-snapshot'
              : 'cart-and-live-banner'
        };


        if (
          !isSatisfied &&
          firstInvalidStepIndex < 0
        ) {
          firstInvalidStepIndex =
            stepIndex;

          firstMissingCount =
            Math.max(
              missing,
              1
            );
        }

        return;
      }


      /*
        Si aucun minimum n'est encore connu,
        on ne réécrit pas le fonctionnement BYOB.

        On conserve le comportement natif existant.
      */

      const nativeComplete =
        nativeStepLooksComplete(
          step
        );


      byStep[
        stepIndex
      ] = {
        stepIndex:
          stepIndex,

        stepName:
          getV2StepName(
            stepIndex
          ),

        selected:
          selectedFromCart,

        minimum:
          0,

        missing:
          nativeComplete
            ? 0
            : 1,

        hasKnownMinimum:
          false,

        isSatisfied:
          nativeComplete,

        source:
          'native-fallback'
      };


      if (
        !nativeComplete &&
        firstInvalidStepIndex < 0
      ) {
        firstInvalidStepIndex =
          stepIndex;

        firstMissingCount =
          1;
      }
    }
  );


  /* =====================================================
     CONTRÔLE GLOBAL SUPPLÉMENTAIRE

     Exemple :
     Coffret = 1
     Collection A = minimum 2
     Collection B = minimum 2
     Carte = minimum 1

     Impossible qu'un panier contenant seulement 5 articles
     satisfasse réellement un minimum total de 6.

     Cela protège notamment contre une mauvaise attribution
     ponctuelle de stepIndex.
  ===================================================== */

  let requiredTotal =
    0;


  byStep.forEach(
    function(state) {

      if (
        !state ||
        !state.hasKnownMinimum
      ) {
        return;
      }

      requiredTotal +=
        Number(
          state.minimum || 0
        );
    }
  );


  const actualTotal =
    snapshot.reduce(
      function(total, item) {
        return (
          total +
          Number(
            item.quantity || 0
          )
        );
      },
      0
    );


  if (
    requiredTotal > 0 &&
    actualTotal < requiredTotal &&
    firstInvalidStepIndex < 0
  ) {

    for (
      let i = 0;
      i < byStep.length;
      i++
    ) {
      if (
        byStep[i] &&
        byStep[i].hasKnownMinimum &&
        !byStep[i].isSatisfied
      ) {
        firstInvalidStepIndex =
          i;

        firstMissingCount =
          Math.max(
            byStep[i].missing || 0,
            1
          );

        break;
      }
    }


    /*
      Cas ultra défensif :
      si les origines sont tellement incohérentes
      qu'on ne peut même pas identifier l'étape,
      on refuse tout de même la finalisation.
    */

    if (
      firstInvalidStepIndex < 0
    ) {
      firstInvalidStepIndex =
        Math.min(
          1,
          steps.length - 1
        );

      firstMissingCount =
        Math.max(
          requiredTotal -
          actualTotal,
          1
        );
    }
  }


  return {
    isValid:
      firstInvalidStepIndex < 0,

    firstInvalidStepIndex:
      firstInvalidStepIndex,

    missingCount:
      firstMissingCount,

    stepName:
      firstInvalidStepIndex >= 0
        ? getV2StepName(
            firstInvalidStepIndex
          )
        : '',

    actualTotal:
      actualTotal,

    requiredTotal:
      requiredTotal,

    byStep:
      byStep
  };
}

























function getFirstIncompleteRequiredStepIndex() {
  const steps =
    getV2Steps();

  if (!steps.length) {
    return -1;
  }

  for (let i = 0; i < steps.length; i++) {
    if (i === 0) {
      if (!nativeStepLooksComplete(steps[i])) {
        return i;
      }

      continue;
    }

    const bannerState =
      getBannerStateForStep(i);

    if (
      bannerState.exists &&
      bannerState.minimum > 0
    ) {
      if (!bannerState.isSatisfied) {
        return i;
      }

      continue;
    }

    if (!nativeStepLooksComplete(steps[i])) {
      return i;
    }
  }

  return -1;
}

function isCardStep(stepIndex) {
  const name =
    getV2StepName(stepIndex)
      .toLowerCase();

  return (
    name.includes('carte') ||
    name.includes('souhait')
  );
}

function formatMissingProductsForCollection(
  count,
  collectionName
) {
  const safeCount =
    Math.max(
      parseInt(count, 10) || 0,
      0
    );

  if (safeCount === 1) {
    return (
      'Encore 1 produit à ajouter dans ' +
      collectionName +
      '.'
    );
  }

  return (
    'Encore ' +
    safeCount +
    ' produits à ajouter dans ' +
    collectionName +
    '.'
  );
}

function formatRequiredProductsForCollection(
  count,
  collectionName
) {
  const safeCount =
    Math.max(
      parseInt(count, 10) || 0,
      0
    );

  if (safeCount === 1) {
    return (
      'Vous devez ajouter 1 autre produit à ' +
      collectionName +
      '.'
    );
  }

  return (
    'Vous devez ajouter ' +
    safeCount +
    ' produits à ' +
    collectionName +
    '.'
  );
}

function getFinalReadyMessage() {
  return (
    'Votre sélection est maintenant suffisamment complète ' +
    'pour créer un beau coffret Lainoha. ' +
    'Vous pouvez le finaliser dès maintenant ou continuer ' +
    'à l’enrichir de quelques coups de cœur.'
  );
}

function getStillReadyMessage() {
  return (
    'Votre coffret est prêt à être finalisé, ' +
    'mais vous pouvez encore l’enrichir ' +
    'de quelques coups de cœur.'
  );
}

function getUnifiedCurrentStatusMessage(forcedStepIndex) {
  const steps =
    getV2Steps();

  if (!steps.length) {
    return 'Commencez à créer votre coffret.';
  }

  const requirement =
    buildRequirementState();

  if (requirement.isComplete) {
    return getFinalReadyMessage();
  }

  let currentIndex =
  Number.isInteger(forcedStepIndex)
    ? forcedStepIndex
    : (
        Number.isInteger(cuSelectedStepIndex)
          ? cuSelectedStepIndex
          : getCurrentV2StepIndex()
      );

if (currentIndex < 0) {
  currentIndex = 0;
}

  const currentName =
    getV2StepName(currentIndex);

  if (currentIndex === 0) {
  const firstComplete =
    nativeStepLooksComplete(steps[0]);

  if (firstComplete) {

    if (cuLastCoffretPopupMessage) {
      return cuLastCoffretPopupMessage;
    }

    return (
      'Votre coffret a été ajouté. ' +
      'Vous pouvez maintenant poursuivre votre coffret.'
    );
  }

  return (
    'Choisissez votre type de coffret pour commencer.'
  );
}

  if (isCardStep(currentIndex)) {
    const cardState =
      getBannerStateForStep(currentIndex);

    if (
      cardState.exists &&
      cardState.isSatisfied
    ) {
      const missingIndex =
        getFirstIncompleteRequiredStepIndex();

      if (
        missingIndex >= 0 &&
        missingIndex < currentIndex
      ) {
        return (
          'Votre carte de souhait est choisie. ' +
          'N’oubliez pas de finaliser ' +
          getV2StepName(missingIndex) +
          ' avant de terminer votre coffret.'
        );
      }
    }

    return (
      'Choisissez maintenant la carte de souhait ' +
      'qui accompagnera votre coffret.'
    );
  }

  const bannerState =
    getBannerStateForStep(currentIndex);

  if (
    bannerState.exists &&
    bannerState.minimum > 0
  ) {
    if (bannerState.selected === 0) {
      if (bannerState.minimum === 1) {
        return (
          'Ajoutez au moins 1 produit dans ' +
          currentName +
          '.'
        );
      }

      return (
        'Ajoutez au moins ' +
        bannerState.minimum +
        ' produits dans ' +
        currentName +
        '.'
      );
    }

    if (!bannerState.isSatisfied) {
      return formatMissingProductsForCollection(
        bannerState.remaining,
        currentName
      );
    }

    const missingIndex =
      getFirstIncompleteRequiredStepIndex();

    if (
      missingIndex >= 0 &&
      missingIndex < currentIndex
    ) {
      return (
        'Minimum nécessaire atteint dans ' +
        currentName +
        '. N’oubliez pas de finaliser ' +
        getV2StepName(missingIndex) +
        ' avant de terminer votre coffret.'
      );
    }

    return (
      'Minimum nécessaire atteint dans ' +
      currentName +
      '. Vous pouvez continuer à magasiner ' +
      'dans cette collection ou passer ' +
      'à la collection suivante.'
    );
  }

  return (
    requirement.translated &&
    requirement.translated !== 'COMPLETE'
  )
    ? requirement.translated
    : 'Continuez à personnaliser votre coffret.';
}

function ensureByobPopup() {
  let layer =
    document.getElementById('cuByobPopupLayer');

  if (!layer) {
    layer =
      document.createElement('div');

    layer.id =
      'cuByobPopupLayer';

    layer.innerHTML = `
      <div
        id="cuByobPopup"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        <button
          type="button"
          id="cuByobPopupClose"
          aria-label="Fermer le message"
        >
          ✕
        </button>

        <div class="cu-byob-popup-head">
          <span
            class="cu-byob-popup-icon"
            id="cuByobPopupIcon"
            aria-hidden="true"
          >
            ✓
          </span>

          <div class="cu-byob-popup-copy">
            <p
              class="cu-byob-popup-title"
              id="cuByobPopupTitle"
            ></p>

            <p
              class="cu-byob-popup-text"
              id="cuByobPopupText"
            ></p>

            <p
              class="cu-byob-popup-note"
              id="cuByobPopupNote"
              hidden
            ></p>

            <div
              class="cu-byob-popup-price"
              id="cuByobPopupPrice"
              hidden
            ></div>
          </div>
        </div>

        <div
          class="cu-byob-popup-actions"
          id="cuByobPopupActions"
        ></div>
      </div>
    `;

    document.body.appendChild(layer);

    const closeButton =
      document.getElementById(
        'cuByobPopupClose'
      );

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        function(event) {
          event.preventDefault();
          event.stopPropagation();
          hideByobPopup();
        }
      );
    }

    document.addEventListener(
      'click',
      function(event) {
        const popup =
          document.getElementById(
            'cuByobPopup'
          );

        if (
          !popup ||
          !popup.classList.contains(
            'cu-byob-popup-visible'
          )
        ) {
          return;
        }

        if (popup.contains(event.target)) {
          return;
        }

        const clickedButton =
          event.target.closest('button');

        const buttonText =
          clickedButton
            ? clickedButton.textContent
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase()
            : '';

        const isProductMutation =
          (
            buttonText.includes(
              'ajouter au coffret'
            ) ||
            event.target.closest(
              '.drawer-remove-btn'
            ) ||
            event.target.closest(
              '.byob-footer-remove-icon'
            )
          );

        if (isProductMutation) {
          return;
        }

        hideByobPopup();
      },
      true
    );
  }

  return layer;
}

function positionByobPopup() {
  const layer =
    document.getElementById(
      'cuByobPopupLayer'
    );

  const tracker =
    document.querySelector(
      '.byob-progress-container.cu-byob-v2-shell'
    );

  if (!layer || !tracker) {
    return;
  }

  const rect =
    tracker.getBoundingClientRect();

  if (window.innerWidth <= 749) {
    let mobileTop =
      rect.top + 2;

    if (mobileTop < 4) {
      mobileTop = 4;
    }

    layer.style.top =
      Math.round(mobileTop) + 'px';

    return;
  }

  let top =
    rect.bottom + 9;

  const viewportHeight =
    window.innerHeight ||
    document.documentElement.clientHeight;

  if (
    !Number.isFinite(top) ||
    top < 8 ||
    top > viewportHeight - 80
  ) {
    top = 68;
  }

  layer.style.top =
    Math.round(top) + 'px';
}

function hideByobPopup() {
  const popup =
    document.getElementById(
      'cuByobPopup'
    );

  if (!popup) {
    return;
  }

  popup.classList.remove(
    'cu-byob-popup-visible'
  );
}

function pulseRecommendedStep(stepIndex) {
  const steps =
    getV2Steps();

  if (
    stepIndex < 0 ||
    stepIndex >= steps.length
  ) {
    return;
  }

  steps.forEach(
    function(step) {
      step.classList.remove(
        'cu-byob-popup-pulse'
      );
    }
  );

  const step =
    steps[stepIndex];

  step.classList.add(
    'cu-byob-popup-pulse'
  );

  if (popupPulseTimer) {
    clearTimeout(popupPulseTimer);
  }

  popupPulseTimer =
    setTimeout(
      function() {
        step.classList.remove(
          'cu-byob-popup-pulse'
        );
      },
      1150
    );
}

function goToV2Step(stepIndex) {
  const steps =
    getV2Steps();

  if (
    stepIndex < 0 ||
    stepIndex >= steps.length
  ) {
    return;
  }

  hideByobPopup();

  const step =
    steps[stepIndex];

  const circle =
    step.querySelector('.circle');

  if (circle) {
    circle.click();
  } else {
    step.click();
  }

  setTimeout(
    function() {
      updateV2StepStates();
      updateProgressMessage();
      updateCartDisplay();
    },
    180
  );
}

function openByobCustomDrawer() {
  hideByobPopup();
  setDrawerState(true);
}

function openByobLiveFromPopup() {

  hideByobPopup();

  if (
    typeof window.LainohaOpenLibrary ===
    'function'
  ) {
    window.LainohaOpenLibrary();
  }

}

function addFinalBundleToCart() {

  /*
    ======================================================
    VERROU FINAL LAINOHA

    On valide le panier RÉEL avant de laisser BYOB
    déclencher l'ajout Shopify.
    ======================================================
  */

  const validation =
    validateRealBYOBRequirements();


  if (!validation.isValid) {

    const invalidIndex =
      validation.firstInvalidStepIndex;


    const stepName =
      validation.stepName ||
      (
        invalidIndex >= 0
          ? getV2StepName(
              invalidIndex
            )
          : 'cette étape'
      );


    const missing =
      Math.max(
        Number(
          validation.missingCount || 0
        ),
        1
      );


    let message = '';


    if (invalidIndex === 0) {

      message =
        'Vous devez choisir votre type de coffret avant de poursuivre.';

    } else if (
      invalidIndex >= 0 &&
      isCardStep(
        invalidIndex
      )
    ) {

      message =
        'Votre coffret n’est pas encore complet. ' +
        'Il manque votre carte de souhait.';

    } else {

      message =
        'Votre coffret n’est pas encore complet. ' +
        (
          missing === 1
            ? 'Il manque 1 produit dans '
            : 'Il manque ' +
              missing +
              ' produits dans '
        ) +
        stepName +
        '.';
    }


    showByobPopup({
      icon:
        '!',

      title:
        'Votre coffret n’est pas encore complet',

      text:
        message,

      showContinue:
        false,

      nextStepIndex:
        invalidIndex >= 0
          ? invalidIndex
          : undefined,

      nextLabel:
        invalidIndex === 0
          ? 'Choisir mon coffret →'
          : (
              invalidIndex >= 0 &&
              isCardStep(
                invalidIndex
              )
            )
            ? 'Choisir ma carte de souhait →'
            : 'Aller à l’étape à compléter →'
    });


    /*
      On remet immédiatement le visuel du Tracker
      en cohérence avec la réalité.
    */

    updateV2StepStates();

    updateProgressMessage(
      invalidIndex >= 0
        ? invalidIndex
        : undefined
    );

    updateCartIcon();


    console.warn(
      '⛔ Finalisation BYOB bloquée par la validation réelle',
      validation
    );


    return false;
  }


  /*
    Deuxième ceinture :

    La validation réelle est notre protection principale.

    Mais si BYOB lui-même annonce encore explicitement
    que le coffret n'est PAS complet, on préfère également
    bloquer plutôt que forcer Shopify.
  */

  const nativeRequirement =
    buildRequirementState();


  if (!nativeRequirement.isComplete) {

    const recommendedIndex =
      getRecommendedStepIndex(
        nativeRequirement
      );


    showByobPopup({
      icon:
        '!',

      title:
        'Votre coffret n’est pas encore complet',

      text:
        'Une étape de votre coffret doit encore être complétée avant de pouvoir l’ajouter au panier.',

      showContinue:
        false,

      nextStepIndex:
        recommendedIndex >= 0
          ? recommendedIndex
          : undefined,

      nextLabel:
        'Aller à l’étape à compléter →'
    });


    if (recommendedIndex >= 0) {
      updateProgressMessage(
        recommendedIndex
      );
    }


    updateV2StepStates();
    updateCartIcon();


    console.warn(
      '⛔ Finalisation BYOB bloquée : BYOB indique encore une exigence incomplète',
      nativeRequirement
    );


    return false;
  }


  /*
    Tout est réellement conforme.

    Seulement maintenant on autorise
    le clic du bouton natif BYOB.
  */

  hideByobPopup();


  const button =
    document.querySelector(
      '#btn-add-to-cart'
    ) ||
    document.querySelector(
      '.btn-add-to-cart'
    ) ||
    document.querySelector(
      '.byob-add-to-cart-button'
    );


  if (!button) {

    console.warn(
      '⚠️ Bouton natif BYOB introuvable'
    );

    return false;
  }


  button.click();


  return true;
}

function makePopupButton(
  label,
  variant,
  handler
) {
  const button =
    document.createElement('button');

  button.type =
    'button';

  button.className =
    'cu-byob-popup-btn ' +
    (
      variant === 'primary'
        ? 'cu-byob-popup-btn-primary'
        : 'cu-byob-popup-btn-secondary'
    );

  button.textContent =
    label;

  button.addEventListener(
    'click',
    function(event) {
      event.preventDefault();
      event.stopPropagation();
      handler();
    }
  );

  return button;
}

function showByobPopup(options) {
  ensureByobPopup();






/*
  CORRECTION QUICK VIEW :
  Replace le calque du popup Lainoha à la fin du <body>
  à chaque affichage afin qu'il reste au-dessus du Quick View.
*/
const cuPopupLayer =
  document.getElementById(
    'cuByobPopupLayer'
  );

if (cuPopupLayer) {
  document.body.appendChild(
    cuPopupLayer
  );
}

positionByobPopup();











  const popup =
    document.getElementById(
      'cuByobPopup'
    );

  const icon =
    document.getElementById(
      'cuByobPopupIcon'
    );

  const title =
    document.getElementById(
      'cuByobPopupTitle'
    );

  const text =
    document.getElementById(
      'cuByobPopupText'
    );

  const note =
    document.getElementById(
      'cuByobPopupNote'
    );

  const price =
    document.getElementById(
      'cuByobPopupPrice'
    );

  const actions =
    document.getElementById(
      'cuByobPopupActions'
    );

  if (
    !popup ||
    !icon ||
    !title ||
    !text ||
    !note ||
    !price ||
    !actions
  ) {
    return;
  }

  icon.textContent =
    options.icon || '✓';

  title.textContent =
    options.title || '';

  text.textContent =
    options.text || '';

  if (options.note) {
    note.textContent =
      options.note;
    note.hidden = false;
  } else {
    note.textContent = '';
    note.hidden = true;
  }

  if (options.price) {
    price.textContent =
      'Total : ' +
      options.price;
    price.hidden = false;
  } else {
    price.textContent = '';
    price.hidden = true;
  }

  actions.innerHTML = '';

  if (options.showContinue !== false) {
    actions.appendChild(
      makePopupButton(
        'Continuer à magasiner',
        'secondary',
        hideByobPopup
      )
    );
  }

  if (options.showDrawer) {
    actions.appendChild(
      makePopupButton(
        'Voir les produits de mon coffret',
        'secondary',
        openByobCustomDrawer
      )
    );
  }

  if (options.showLive) {
    actions.appendChild(
      makePopupButton(
        'Une surprise vous attend',
        'secondary',
        openByobLiveFromPopup
      )
    );
  }

  if (
    Number.isInteger(
      options.nextStepIndex
    ) &&
    options.nextStepIndex >= 0
  ) {
    actions.appendChild(
      makePopupButton(
        options.nextLabel ||
        'Passer à l’étape suivante →',
        'primary',
        function() {
          goToV2Step(
            options.nextStepIndex
          );
        }
      )
    );

    if (options.pulseNext !== false) {
      pulseRecommendedStep(
        options.nextStepIndex
      );
    }
  }

  if (options.finalize) {
    actions.appendChild(
      makePopupButton(
        'Ajouter mon coffret au panier',
        'primary',
        addFinalBundleToCart
      )
    );
  }

  /*
  CORRECTION QUICK VIEW :
  force le popup à se réafficher proprement à chaque nouvel ajout,
  même s'il avait déjà été affiché auparavant.
*/

popup.classList.remove(
  'cu-byob-popup-visible'
);

void popup.offsetWidth;

popup.classList.add(
  'cu-byob-popup-visible'
);
}

function showPopupForCartChange(
  previousTotal,
  newTotal,
  previousRequirement,
  newRequirement,
  changeContext,
  previousBannerStates
) {
  const delta =
    newTotal - previousTotal;

  if (!delta) return;

  const boxSizeNote =
    'Nous adaptons la taille de votre coffret selon la quantité et le format des produits sélectionnés.';

  const changedStepIndex =
    changeContext &&
    Number.isInteger(
      changeContext.stepIndex
    )
      ? changeContext.stepIndex
      : getCurrentV2StepIndex();

  const changedCollection =
    (
      changeContext &&
      changeContext.collectionName
    )
      ? changeContext.collectionName
      : getV2StepName(
          changedStepIndex
        );

  const currentBannerState =
    changedStepIndex >= 0
      ? getBannerStateForStep(
          changedStepIndex
        )
      : null;

  const previousBannerState =
    (
      previousBannerStates &&
      changedStepIndex >= 0
    )
      ? previousBannerStates[
          changedStepIndex
        ]
      : null;

  const firstIncompleteIndex =
    getFirstIncompleteRequiredStepIndex();


  /* =====================================================
   AJOUT D'UN PRODUIT
===================================================== */

if (delta > 0) {

  /* ===== ÉTAPE 1 — COFFRET ===== */

  if (changedStepIndex === 0) {

    if (newRequirement.isComplete) {
      showByobPopup({
        icon: '✨',
        title:
          'Votre coffret est maintenant complet !',
        text:
          getFinalReadyMessage(),
        note:
          boxSizeNote,
        price:
          getCurrentBYOBPrice(),
        showContinue:
          true,
        showDrawer:
          false,
        showLive:
          true,
        finalize:
          true
      });

      return;
    }

    const nextRequiredIndex =
  getFirstIncompleteRequiredStepIndex();

if (
  nextRequiredIndex > 0
) {
  const popupTitle =
    'Votre coffret a été ajouté.';

  const popupText =
    'Vous pouvez maintenant passer à l’étape ' +
    (nextRequiredIndex + 1) +
    '.';

  cuLastCoffretPopupMessage =
    popupTitle + ' ' + popupText;

  showByobPopup({
    icon: '✓',
    title:
      popupTitle,
    text:
      popupText,
    showContinue:
      false,
    nextStepIndex:
      nextRequiredIndex,
    nextLabel:
      'Passer à l’étape suivante →'
  });

  return;
}

    showByobPopup({
        icon: '✓',
        title:
          'Votre coffret a été ajouté.',
        text:
          'Vous pouvez maintenant passer à l’étape 2.',
        showContinue:
          false,
        nextStepIndex:
          1,
        nextLabel:
          'Passer à l’étape suivante →'
      });

      return;
    }


    /* ===== LE COFFRET DEVIENT COMPLET ===== */

    if (
      newRequirement.isComplete &&
      !previousRequirement.isComplete
    ) {
      showByobPopup({
        icon: '✨',
        title:
          'Votre coffret est prêt à être finalisé !',
        text:
          getFinalReadyMessage(),
        note:
          boxSizeNote,
        price:
          getCurrentBYOBPrice(),
        showContinue:
          true,
        showDrawer:
          false,
        showLive:
          true,
        finalize:
          true
      });

      return;
    }


    /* ===== AJOUT SUPPLÉMENTAIRE À UN COFFRET DÉJÀ COMPLET ===== */

    if (
      newRequirement.isComplete &&
      previousRequirement.isComplete
    ) {
      showByobPopup({
        icon: '✓',
        title:
          'Un coup de cœur de plus !',
        text:
          getStillReadyMessage(),
        note:
          boxSizeNote,
        price:
          getCurrentBYOBPrice(),
        showContinue:
          true,
        showDrawer:
          false,
        showLive:
          true,
        finalize:
          true
      });

      return;
    }


    /* ===== CARTE CHOISIE MAIS ÉTAPE ANTÉRIEURE INCOMPLÈTE ===== */

    if (
      changedStepIndex >= 0 &&
      isCardStep(changedStepIndex) &&
      firstIncompleteIndex >= 0 &&
      firstIncompleteIndex <
        changedStepIndex
    ) {
      showByobPopup({
        icon: '✓',
        title:
          'Votre carte de souhait est choisie !',
        text:
          'N’oubliez pas de finaliser ' +
          getV2StepName(
            firstIncompleteIndex
          ) +
          ' avant de terminer votre coffret.',
        nextStepIndex:
          firstIncompleteIndex,
        nextLabel:
          'Aller à l’étape à compléter →'
      });

      return;
    }


    /* ===== MINIMUM PAS ENCORE ATTEINT ===== */

    if (
      currentBannerState &&
      currentBannerState.exists &&
      currentBannerState.minimum > 0 &&
      !currentBannerState.isSatisfied
    ) {
      showByobPopup({
        icon: '✓',
        title:
          'Produit ajouté à votre coffret',
        text:
          formatMissingProductsForCollection(
            currentBannerState.remaining,
            changedCollection
          )
      });

      return;
    }


    /* ===== MINIMUM VIENT D'ÊTRE ATTEINT ===== */

    if (
      currentBannerState &&
      currentBannerState.exists &&
      currentBannerState.isSatisfied &&
      previousBannerState &&
      !previousBannerState.isSatisfied
    ) {

      if (
        firstIncompleteIndex >= 0 &&
        firstIncompleteIndex <
          changedStepIndex
      ) {
        showByobPopup({
          icon: '✓',
          title:
            'Minimum nécessaire atteint !',
          text:
            'Votre sélection dans ' +
            changedCollection +
            ' est suffisante. ' +
            'N’oubliez pas de finaliser ' +
            getV2StepName(
              firstIncompleteIndex
            ) +
            ' avant de terminer votre coffret.',
          note:
            boxSizeNote,
          nextStepIndex:
            firstIncompleteIndex,
          nextLabel:
            'Aller à l’étape à compléter →'
        });

        return;
      }

      const nextIndex =
        Math.min(
          changedStepIndex + 1,
          getV2Steps().length - 1
        );

      showByobPopup({
        icon: '✓',
        title:
          'Minimum nécessaire atteint !',
        text:
          'Vous pouvez continuer à magasiner dans ' +
          changedCollection +
          ' ou passer dès maintenant à la prochaine collection.',
        note:
          boxSizeNote,
        nextStepIndex:
          nextIndex,
        nextLabel:
          'Passer à la collection suivante →'
      });

      return;
    }


    /* ===== MINIMUM ÉTAIT DÉJÀ ATTEINT ===== */

    if (
      currentBannerState &&
      currentBannerState.exists &&
      currentBannerState.isSatisfied
    ) {

      if (
        firstIncompleteIndex >= 0 &&
        firstIncompleteIndex <
          changedStepIndex
      ) {
        showByobPopup({
          icon: '✓',
          title:
            'Produit ajouté à votre coffret',
          text:
            'Votre sélection dans ' +
            changedCollection +
            ' demeure suffisante. ' +
            'N’oubliez pas de finaliser ' +
            getV2StepName(
              firstIncompleteIndex
            ) +
            ' avant de terminer votre coffret.',
          note:
            boxSizeNote,
          nextStepIndex:
            firstIncompleteIndex,
          nextLabel:
            'Aller à l’étape à compléter →'
        });

        return;
      }

      const nextIndex =
        Math.min(
          changedStepIndex + 1,
          getV2Steps().length - 1
        );

      showByobPopup({
        icon: '✓',
        title:
          'Un coup de cœur de plus !',
        text:
          'Le minimum nécessaire est déjà atteint dans ' +
          changedCollection +
          '. Vous pouvez continuer à personnaliser votre coffret ou passer à la suite.',
        note:
          boxSizeNote,
        nextStepIndex:
          nextIndex,
        nextLabel:
          'Passer à la collection suivante →'
      });

      return;
    }


    /* ===== AJOUT — CAS DE SECOURS ===== */

    showByobPopup({
      icon: '✓',
      title:
        'Produit ajouté à votre coffret',
      text:
        'Votre sélection a bien été mise à jour.'
    });

    return;
  }


  /* =====================================================
     RETRAIT D'UN PRODUIT
  ===================================================== */

  if (delta < 0) {

    /* ===== RETRAIT DU COFFRET ===== */

    if (
      changedStepIndex === 0
    ) {
      showByobPopup({
        icon: '!',
        title:
          'Coffret retiré',
        text:
          'Vous devez choisir votre type de coffret pour poursuivre.',
        nextStepIndex:
          0,
        nextLabel:
          'Choisir mon coffret →'
      });

      return;
    }


    /* ===== RETRAIT DE LA CARTE ===== */

    if (
      changedStepIndex >= 0 &&
      isCardStep(changedStepIndex)
    ) {
      showByobPopup({
        icon: '!',
        title:
          'Produit retiré de votre coffret',
        text:
          'Vous devez ajouter 1 carte de souhait pour compléter votre coffret.',
        nextStepIndex:
          changedStepIndex,
        nextLabel:
          'Choisir ma carte de souhait →'
      });

      return;
    }


    /* ===== COLLECTION ENCORE SUFFISANTE ===== */

    if (
      currentBannerState &&
      currentBannerState.exists &&
      currentBannerState.isSatisfied
    ) {

      if (
        firstIncompleteIndex >= 0 &&
        firstIncompleteIndex <
          changedStepIndex
      ) {
        showByobPopup({
          icon: '✓',
          title:
            'Produit retiré de votre coffret',
          text:
            'Votre sélection dans ' +
            changedCollection +
            ' demeure suffisante. ' +
            'N’oubliez pas de finaliser ' +
            getV2StepName(
              firstIncompleteIndex
            ) +
            ' avant de terminer votre coffret.',
          nextStepIndex:
            firstIncompleteIndex,
          nextLabel:
            'Aller à l’étape à compléter →'
        });

        return;
      }

      showByobPopup({
        icon: '✓',
        title:
          'Produit retiré de votre coffret',
        text:
          'Votre sélection dans ' +
          changedCollection +
          ' demeure suffisante.'
      });

      return;
    }


    /* ===== RETRAIT QUI FAIT PASSER SOUS LE MINIMUM ===== */

    if (
      currentBannerState &&
      currentBannerState.exists &&
      currentBannerState.remaining > 0
    ) {
      showByobPopup({
        icon: '!',
        title:
          'Produit retiré de votre coffret',
        text:
          formatRequiredProductsForCollection(
            currentBannerState.remaining,
            changedCollection
          ),
        nextStepIndex:
          changedStepIndex,
        nextLabel:
          'Retourner à cette collection →'
      });

      return;
    }


    /* ===== RETRAIT — CAS DE SECOURS ===== */

    showByobPopup({
      icon: '✓',
      title:
        'Produit retiré de votre coffret',
      text:
        'Votre sélection a bien été mise à jour.'
    });
  }
}

function startPopupMonitoring() {
  setTimeout(
    function() {
      applyKnownProductOrigins();

      popupMonitorState.totalItems =
        getBYOBTotalItems();

      popupMonitorState.requirement =
        buildRequirementState();

      popupMonitorState.cartSnapshot =
        captureNativeCartSnapshot();

      popupMonitorState.bannerStates =
        captureAllBannerStates();

      popupMonitorState.initialized =
        true;

      console.log(
        '✅ Popups BYOB V2 initialisés'
      );
    },
    700
  );

  setInterval(
    function() {
      if (!popupMonitorState.initialized) {
        return;
      }

      const currentTotal =
        getBYOBTotalItems();

      if (
        currentTotal ===
        popupMonitorState.totalItems
      ) {
        return;
      }

      const previousTotal =
        popupMonitorState.totalItems;

      const previousRequirement =
        popupMonitorState.requirement ||
        buildRequirementState();

      const previousSnapshot =
        popupMonitorState.cartSnapshot ||
        [];

      const previousBannerStates =
        popupMonitorState.bannerStates ||
        [];

      const actionStepIndex =
        getCurrentV2StepIndex();

      popupMonitorState.totalItems =
        currentTotal;

      setTimeout(
        function() {
          const settledTotal =
            getBYOBTotalItems();

          if (
            settledTotal >
            previousTotal
          ) {
            rememberAddedProductOrigins(
              previousSnapshot,
              actionStepIndex
            );
          }

          applyKnownProductOrigins();

          const currentSnapshot =
  captureNativeCartSnapshot();

syncBannerStateMemoryFromCartSnapshot(
  currentSnapshot
);

const delta =
  settledTotal -
  previousTotal;

          const changeContext =
            findCartChangeContext(
              previousSnapshot,
              currentSnapshot,
              delta
            );


            if (
  delta < 0 &&
  changeContext &&
  Number.isInteger(
    changeContext.stepIndex
  )
) {
  cuSelectedStepIndex =
    changeContext.stepIndex;
}

          const newRequirement =
            buildRequirementState();

          updateV2StepStates();

if (
  delta < 0 &&
  changeContext &&
  Number.isInteger(
    changeContext.stepIndex
  )
) {
  updateProgressMessage(
    changeContext.stepIndex
  );
} else {
  updateProgressMessage();
}

updateCartDisplay();
positionDrawer();

          showPopupForCartChange(
  previousTotal,
  settledTotal,
  previousRequirement,
  newRequirement,
  changeContext,
  previousBannerStates
);

/*
  Le popup vient maintenant de déterminer
  le message exact.

  On actualise une deuxième fois le tracker
  afin qu'il puisse reprendre exactement
  ce message dans le cas du coffret remis.
*/
if (
  delta > 0 &&
  changeContext &&
  changeContext.stepIndex === 0
) {
  updateProgressMessage(0);
}

popupMonitorState.totalItems =
  settledTotal;

          popupMonitorState.requirement =
            newRequirement;

          popupMonitorState.cartSnapshot =
            currentSnapshot;

          popupMonitorState.bannerStates =
            captureAllBannerStates();
        },
        260
      );
    },
    250
  );
}

function getCartSVG() {
  return `<svg class="byob-cart-svg" viewBox="0 0 24 24" fill="none" stroke="#888888" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  </svg>`;
}

function init() {
  console.log(
    '🎯 BYOB Progress Tracker initialisé'
  );

  lockBYOBFooterOpen();
  waitForBYOB();
}

function waitForBYOB() {
  let attempts = 0;
  const maxAttempts = 40;

  const checkBYOB =
    setInterval(
      () => {
        attempts++;

        const byobAnchor =
          document.getElementById(
            'byob-tracker-anchor'
          );

        if (byobAnchor) {
          clearInterval(checkBYOB);

          console.log(
            '✅ Balise BYOB ancre détectée'
          );

          setTimeout(
            () => {
              buildProgressUI();
              setupCartObserver();
              startMessagePolling();
              startPopupMonitoring();
            },
            1000
          );
        }

        if (attempts >= maxAttempts) {
          clearInterval(checkBYOB);

          console.warn(
            '⚠️ Balise BYOB ancre non détectée après 20 secondes'
          );
        }
      },
      500
    );
}

function getV2Steps() {
  const circleSteps =
    document.querySelector(
      '.byob-circle-steps'
    );

  if (!circleSteps) return [];

  return Array.from(
    circleSteps.querySelectorAll(
      '.circle-step'
    )
  );
}

function nativeStepLooksComplete(step) {
  if (!step) return false;

  const nativeClasses =
    Array.from(step.classList)
      .filter(function(className) {
        return !className.startsWith(
          'cu-v2-'
        );
      })
      .join(' ')
      .toLowerCase();

  if (
    nativeClasses.includes('complete') ||
    nativeClasses.includes('completed') ||
    nativeClasses.includes('success') ||
    nativeClasses.includes('done')
  ) {
    return true;
  }

  const text =
    step.textContent
      .replace(/\s+/g, ' ')
      .trim();

  if (
    text.includes('✓') ||
    text.includes('✔')
  ) {
    return true;
  }

  const checkLike =
    step.querySelector(
      '.check, .checked, .checkmark, [class*="check"]'
    );

  if (checkLike) {
    return true;
  }

  return false;
}

function nativeStepLooksCurrent(step) {
  if (!step) return false;

  const nativeClasses =
    Array.from(step.classList)
      .filter(function(className) {
        return !className.startsWith(
          'cu-v2-'
        );
      })
      .join(' ')
      .toLowerCase();

  if (
    nativeClasses.includes('active') ||
    nativeClasses.includes('current') ||
    nativeClasses.includes('selected')
  ) {
    return true;
  }

  if (
    step.getAttribute('aria-current') === 'step' ||
    step.getAttribute('aria-current') === 'true'
  ) {
    return true;
  }

  if (
    step.querySelector(
      '.active, .current, .selected, [aria-current="step"], [aria-current="true"]'
    )
  ) {
    return true;
  }

  return false;
}

function ensureV2ProgressTrack() {
  const circleSteps =
    document.querySelector(
      '.byob-circle-steps'
    );

  if (!circleSteps) return;

  let track =
    circleSteps.querySelector(
      '.cu-byob-v2-track'
    );

  if (!track) {
    track =
      document.createElement('div');

    track.className =
      'cu-byob-v2-track';

    track.innerHTML =
      '<div class="cu-byob-v2-track-fill"></div>';

    circleSteps.insertBefore(
      track,
      circleSteps.firstChild
    );
  }
}

function updateV2StepStates() {
  const steps = getV2Steps();

  if (!steps.length) return;

  ensureV2ProgressTrack();

    const realValidation =
    validateRealBYOBRequirements();


  const completed =
    steps.map(
      function(step, index) {

        const realState =
          realValidation.byStep[
            index
          ];


        /*
          Quand notre validation connaît réellement
          le minimum de cette étape, ELLE a priorité.

          Une ancienne valeur verte en mémoire
          ne peut donc plus forcer le cercle au vert.
        */

        if (
          realState &&
          realState.hasKnownMinimum
        ) {
          return (
            realState.isSatisfied ===
            true
          );
        }


        /*
          Fallback conservateur :
          pour une étape dont nous ne connaissons
          pas encore le minimum, on garde exactement
          l'ancien comportement.
        */

        if (index === 0) {
          return nativeStepLooksComplete(
            step
          );
        }


        const bannerState =
          getBannerStateForStep(
            index
          );


        if (
          bannerState.exists &&
          bannerState.minimum > 0
        ) {
          return (
            bannerState.isSatisfied ===
            true
          );
        }


        return nativeStepLooksComplete(
          step
        );
      }
    );

  let currentIndex =
    steps.findIndex(function(step) {
      return nativeStepLooksCurrent(step);
    });

  if (currentIndex < 0) {
    currentIndex = 0;
  }

  let consecutiveCompleted = 0;

  for (
    let i = 0;
    i < completed.length;
    i++
  ) {
    if (completed[i]) {
      consecutiveCompleted++;
    } else {
      break;
    }
  }

  let missingIndex = -1;

  for (
    let i = 0;
    i < completed.length;
    i++
  ) {
    if (completed[i]) continue;

    const laterCompleted =
      completed
        .slice(i + 1)
        .some(Boolean);

    if (laterCompleted) {
      missingIndex = i;
      break;
    }
  }

  steps.forEach(function(step, index) {
    step.classList.remove(
      'cu-v2-current',
      'cu-v2-complete',
      'cu-v2-missing',
      'cu-v2-current-out-of-order'
    );

    if (completed[index]) {
      step.classList.add(
        'cu-v2-complete'
      );
    }

    if (index === missingIndex) {
      step.classList.add(
        'cu-v2-missing'
      );
    }

    if (index === currentIndex) {
      const previousIncomplete =
        completed
          .slice(0, index)
          .some(function(value) {
            return !value;
          });

      if (previousIncomplete) {
        step.classList.add(
          'cu-v2-current-out-of-order'
        );
      } else {
        step.classList.add(
          'cu-v2-current'
        );
      }
    }
  });

  const track =
    document.querySelector(
      '.cu-byob-v2-track'
    );

  if (track) {
    const firstIncompleteIndex =
      Math.min(
        consecutiveCompleted,
        steps.length - 1
      );

    let partialProgress = 0;

    if (
      consecutiveCompleted <
      steps.length
    ) {
      const bannerState =
        getBannerStateForStep(
          firstIncompleteIndex
        );

      if (
        bannerState.exists &&
        bannerState.minimum > 0
      ) {
        partialProgress =
          Math.min(
            Math.max(
              bannerState.selected /
              bannerState.minimum,
              0
            ),
            1
          );
      }
    }

    const trackRect =
      track.getBoundingClientRect();

    const circleCenters =
      steps.map(function(step) {
        const circle =
          step.querySelector('.circle');

        if (!circle) return null;

        const rect =
          circle.getBoundingClientRect();

        return (
          rect.left +
          rect.width / 2
        );
      });

    if (
      circleCenters.every(
        function(value) {
          return value !== null;
        }
      ) &&
      trackRect.width > 0
    ) {
      let targetX;

      if (
        consecutiveCompleted >=
        steps.length
      ) {
        targetX =
          circleCenters[
            circleCenters.length - 1
          ];
      } else {
        const currentCenter =
          circleCenters[
            firstIncompleteIndex
          ];

        if (
          firstIncompleteIndex <
          circleCenters.length - 1
        ) {
          const nextCenter =
            circleCenters[
              firstIncompleteIndex + 1
            ];

          targetX =
            currentCenter +
            (
              nextCenter -
              currentCenter
            ) *
            partialProgress;
        } else {
          targetX = currentCenter;
        }
      }

      const percent =
        Math.min(
          Math.max(
            (
              (
                targetX -
                trackRect.left
              ) /
              trackRect.width
            ) * 100,
            0
          ),
          100
        );

      track.style.setProperty(
        '--cu-progress',
        percent + '%'
      );
    }
  }
}

function prepareV2StepLabels() {
  const circleSteps =
    document.querySelector(
      '.byob-circle-steps'
    );

  if (!circleSteps) return;

  const steps =
    Array.from(
      circleSteps.querySelectorAll(
        '.circle-step'
      )
    );

  steps.forEach(function(step, index) {
    const oldLabel =
      step.querySelector(
        '.cu-byob-v2-step-label'
      );

    if (oldLabel) {
      oldLabel.remove();
    }

    const stepNumber =
      index + 1;

    let text = '';

    if (index === 0) {
      text = 'Coffret';
    }

    if (!text) {
      const banner =
        document.querySelector(
          '.cu-byob-rule-banner[data-step="' +
          stepNumber +
          '"]'
        );

      if (banner) {
        const bannerTitle =
          banner.querySelector(
            '.cu-rule-title'
          );

        if (bannerTitle) {
          text =
            bannerTitle.textContent
              .trim()
              .replace(/^Collection\s*[—–-]\s*/i, '')
              .replace(/^Choisissez\s+/i, '')
              .replace(/^Ajoutez\s+/i, '')
              .replace(/\s+/g, ' ')
              .trim();
        }
      }
    }






















    if (!text) {

  /*
    Depuis que BYOB n'ouvre plus toutes les étapes
    au chargement, certaines bannières ne sont pas
    encore présentes dans le DOM.

    On récupère donc d'abord le vrai nom complet
    directement dans buildrules, avant de tomber
    sur le titre natif BYOB qui peut être tronqué.
  */
  if (
    typeof buildrules !== 'undefined' &&
    Array.isArray(buildrules) &&
    buildrules[index]
  ) {
    text =
      String(
        buildrules[index].title ||
        buildrules[index].handle ||
        ''
      )
        .replace(/l['’]?étape\s*\d+\s*[-–—:]*/i, '')
        .replace(/étape\s*\d+\s*[-–—:]*/i, '')
        .replace(/\bbyob\b/ig, '')
        .replace(/^collection\s*[—–-]\s*/i, '')
        .replace(/^choisissez\s+/i, '')
        .replace(/^ajoutez\s+/i, '')
        .replace(/\s+/g, ' ')
        .trim();
  }

  /*
    Plan B :
    si buildrules n'est pas encore disponible,
    on garde le comportement précédent.
  */
  if (!text) {
    const nativeTitle =
      step.querySelector(
        '.circle-step-title'
      );

    text =
      nativeTitle
        ? nativeTitle.textContent.trim()
        : 'Étape ' + stepNumber;

    text = text
      .replace(/l['’]?étape\s*\d+\s*[-–—:]*/i, '')
      .replace(/étape\s*\d+\s*[-–—:]*/i, '')
      .replace(/\bbyob\b/ig, '')
      .replace(/^collection\s*[—–-]\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
}





























    if (
      /carte/i.test(text) &&
      /souhait/i.test(text)
    ) {
      text = 'Carte';
    }

    if (/tous les produits/i.test(text)) {
      text = 'Tous les produits';
    }

    if (!text) {
      text = 'Étape ' + stepNumber;
    }

    const label =
      document.createElement('span');

    label.className =
      'cu-byob-v2-step-label';

    label.textContent =
      text;

    step.appendChild(label);
  });
}


function ensureStartCreationCue() {

  function findStartButton() {
    const candidates =
      Array.from(
        document.querySelectorAll(
          'a, button'
        )
      );

    return candidates.find(
      function(element) {
        const text =
          element.textContent
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

        return (
          text.includes(
            'commencer la création'
          ) ||
          text.includes(
            'commencer ma création'
          ) ||
          text.includes(
            'commencer votre coffret'
          )
        );
      }
    );
  }

  function forceStartCueVisible() {
    const startButton =
      findStartButton();

    if (!startButton) {
      return;
    }

    startButton.classList.add(
      'cu-byob-start-button-found'
    );

    startButton.style.setProperty(
      'display',
      'inline-flex',
      'important'
    );

    startButton.style.setProperty(
      'visibility',
      'visible',
      'important'
    );

    startButton.style.setProperty(
      'opacity',
      '1',
      'important'
    );

    startButton.style.setProperty(
      'transform',
      'none',
      'important'
    );

    let parent =
      startButton.parentElement;

    for (
      let level = 0;
      level < 2 && parent;
      level++
    ) {
      const style =
        window.getComputedStyle(
          parent
        );

      if (style.display === 'none') {
        parent.style.setProperty(
          'display',
          'block',
          'important'
        );
      }

      if (style.visibility === 'hidden') {
        parent.style.setProperty(
          'visibility',
          'visible',
          'important'
        );
      }

      if (
        parseFloat(style.opacity) === 0
      ) {
        parent.style.setProperty(
          'opacity',
          '1',
          'important'
        );
      }

      parent =
        parent.parentElement;
    }
  }

  forceStartCueVisible();

  const observer =
    new MutationObserver(
      function() {
        forceStartCueVisible();
      }
    );

  observer.observe(
    document.body,
    {
      attributes: true,
      attributeFilter: [
        'class',
        'style'
      ],
      subtree: true
    }
  );

  window.addEventListener(
    'resize',
    forceStartCueVisible
  );
}

function buildProgressUI() {
  const circleSteps =
    document.querySelector(
      '.byob-circle-steps'
    );

  if (!circleSteps) {
    console.warn(
      '⚠️ .byob-circle-steps non trouvé'
    );
    return;
  }

  if (
    document.querySelector(
      '.byob-progress-container'
    )
  ) {
    console.log(
      '✅ Interface déjà créée'
    );
    return;
  }

  const progressContainer =
    document.createElement('div');

  progressContainer.className =
    'byob-progress-container cu-byob-v2-shell';

  progressContainer.innerHTML = `
    <div class="cu-byob-v2-layout">

      <div class="cu-byob-v2-left">
        <button
          type="button"
          class="cu-byob-v2-cart"
          id="byobCartIcon"
          aria-label="Voir les produits de votre coffret"
        >
          ${getCartSVG()}

          <span
            class="cu-byob-v2-cart-summary"
            id="cuByobCartSummary"
          >
            0 produit | 0,00 $
          </span>

          <span class="cart-count">0</span>
        </button>
      </div>

      <div class="cu-byob-v2-center">

        <div class="byob-timeline-wrapper"></div>

        <div
          class="byob-progress-message"
          id="progressMessage"
        >
          <span class="byob-progress-message-inner">
            Commencez à créer votre coffret
          </span>
        </div>

      </div>

      <div class="cu-byob-v2-right">

        <button
          type="button"
          class="cu-byob-v2-finalize"
          id="cuByobFinalizeButton"
          hidden
        >
          Ajouter mon coffret au panier
        </button>

        <button
          type="button"
          class="cu-byob-v2-live"
          id="cuByobLiveButton"
        >
          Une surprise vous attend
        </button>

      </div>

    </div>


  `;

  circleSteps.parentNode.insertBefore(
    progressContainer,
    circleSteps
  );

  const timelineWrapper =
    progressContainer.querySelector(
      '.byob-timeline-wrapper'
    );

  timelineWrapper.appendChild(
    circleSteps
  );

  const drawer =
    document.createElement('div');

  drawer.className =
    'byob-cart-drawer';

  drawer.id =
    'cartDrawer';

  drawer.innerHTML = `
    <button
      class="byob-drawer-close-floating"
      id="closeDrawer"
      aria-label="Fermer"
    >
      ✕
    </button>

    <div class="drawer-header">
      <h3>Votre coffret</h3>
    </div>

    <div
      class="drawer-content"
      id="drawerContent"
    >
      <p>Votre coffret est vide</p>
    </div>
  `;

  document.body.appendChild(
    drawer
  );

  prepareV2StepLabels();
  ensureV2ProgressTrack();
  updateV2StepStates();

  setTimeout(
    function() {
      positionDrawer();
      updateCartIcon();
    },
    120
  );

  window.addEventListener(
    'resize',
    function() {
      positionDrawer();
      positionByobPopup();
    }
  );

  window.addEventListener(
    'scroll',
    function() {
      positionDrawer();
      positionByobPopup();
    }
  );

  setupEventListeners();

  // ensureStartCreationCue();

  console.log(
    '✅ Interface BYOB V2 créée'
  );
}

function positionDrawer() {
  const drawer =
    document.getElementById(
      'cartDrawer'
    );

  const progressContainer =
    document.querySelector(
      '.byob-progress-container'
    );

  if (
    !drawer ||
    !progressContainer
  ) {
    return;
  }

  const rect =
    progressContainer
      .getBoundingClientRect();

  drawer.style.top =
    rect.bottom + 'px';
}

function setDrawerState(isOpen) {
  const drawer =
    document.getElementById(
      'cartDrawer'
    );

  const progressContainer =
    document.querySelector(
      '.byob-progress-container'
    );

  if (
    !drawer ||
    !progressContainer
  ) {
    return;
  }

  if (isOpen) {
    drawer.classList.add(
      'open'
    );

    progressContainer.classList.add(
      'drawer-open'
    );

    updateCartDisplay();
    positionDrawer();

    console.log(
      '🛒 Drawer ouvert'
    );
  } else {
    drawer.classList.remove(
      'open'
    );

    progressContainer.classList.remove(
      'drawer-open'
    );

positionDrawer();

    console.log(
      '✕ Drawer fermé'
    );
  }
}

function setupCartObserver() {
  const byobContainer =
    document.querySelector(
      '.byob-circle-steps'
    ) ||
    document.body;

  if (byobContainer) {
    const observer =
      new MutationObserver(
        () => {
          updateCartState();
          updateV2StepStates();
          positionDrawer();
        }
      );

    observer.observe(
      byobContainer,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );

    console.log(
      '✅ Observer configuré'
    );
  }
}

function startMessagePolling() {
  let lastMessage = '';
  let lastImages = '';

  setInterval(
    () => {
      const currentMessage =
        translateBYOBMessage();

      const images =
        Array.from(
          document.querySelectorAll(
            '.byob-footer-thumbnail-image img'
          )
        )
          .map(img => img.src)
          .join('|');

      const quantities =
        Array.from(
          document.querySelectorAll(
            '.byob-footer-thumbnail-detail div'
          )
        )
          .map(
            d => d.textContent.trim()
          )
          .join('|');

      const currentSnapshot =
        images +
        '||' +
        quantities;

      console.log(
        'quantities:',
        quantities
      );

      if (
        currentSnapshot !==
        lastImages
      ) {
        lastImages =
          currentSnapshot;

        let realTotal = 0;

        document
          .querySelectorAll(
            '.byob-footer-card'
          )
          .forEach(card => {
            const detail =
              card.querySelector(
                '.byob-footer-thumbnail-detail'
              );

            const qtyDiv =
              detail
                ? Array.from(
                    detail.querySelectorAll(
                      'div'
                    )
                  ).find(
                    function(d) {
                      return d.textContent
                        .trim()
                        .startsWith('x');
                    }
                  )
                : null;

            const qty =
              qtyDiv
                ? parseInt(
                    qtyDiv.textContent
                      .trim()
                      .replace('x', '')
                      .trim()
                  ) || 1
                : 1;

            realTotal += qty;
          });

        cartState.totalItems =
          realTotal;

        updateCartIcon();
        updateCartDisplay();

        updateProgressMessage(
          cuSelectedStepIndex
        );

        updateProgressImage();
        positionDrawer();

        setTimeout(
          function() {
            updateV2StepStates();
          },
          150
        );
      }

      if (
        currentMessage !==
        lastMessage
      ) {
        lastMessage =
          currentMessage;

        updateProgressMessage(
          cuSelectedStepIndex
        );

        updateCartDisplay();
      }
    },
    500
  );
}

function updateCartState() {
  if (isUpdating) return;

  isUpdating = true;

  let items = 0;

  document
    .querySelectorAll(
      '.byob-footer-thumbnail-detail div'
    )
    .forEach(d => {
      const text =
        d.textContent.trim();

      if (text.startsWith('x')) {
        items +=
          parseInt(
            text
              .replace('x', '')
              .trim()
          ) || 0;
      }
    });

  const addToCartBtn =
    document.querySelector(
      '.byob-add-to-cart-button'
    ) ||
    document.querySelector(
      '[class*="byob"][class*="add-to-cart"]'
    );

  const isComplete =
    addToCartBtn &&
    !addToCartBtn.disabled &&
    !addToCartBtn.classList.contains(
      'disabled'
    );

  const hasChanged =
    cartState.totalItems !== items ||
    cartState.isComplete !==
      isComplete;

  if (hasChanged) {
    cartState.totalItems =
      items;

    cartState.isComplete =
      isComplete;

    updateCartIcon();
    updateCartDisplay();
    updateProgressMessage(
      cuSelectedStepIndex
    );
  }

  setTimeout(
    () => {
      isUpdating = false;
    },
    100
  );
}

/* ============================================================
   IMPORTANT — MESSAGES BYOB ET NOMS DES COLLECTIONS
============================================================ */

function translateBYOBMessage() {
  const byobWarning =
    document.querySelector(
      '#btn-add-to-cart span'
    ) ||
    document.querySelector(
      '.btn-add-to-cart span'
    );

  const byobMessage =
    byobWarning
      ?.textContent
      ?.trim() || '';

  const msgLower =
    byobMessage.toLowerCase();

  if (!byobMessage) {
    return "Allez à l'étape 1 et ajoutez votre type de coffret";
  }

  if (
    msgLower.includes(
      'ajouter le kit au panier'
    ) ||
    msgLower.includes(
      'ajouter au panier'
    )
  ) {
    return 'COMPLETE';
  }

  if (
    msgLower.includes('byob') &&
    msgLower.includes(
      'tous les produits'
    ) &&
    msgLower.includes('ajouter 4')
  ) {
    return "Allez à l'étape 2 et ajoutez au moins 4 produits de cette collection";
  }

  if (
    msgLower.includes('byob') &&
    msgLower.includes(
      'tous les produits'
    ) &&
    msgLower.includes('ajouter 3')
  ) {
    return "Continuez à ajouter au moins 3 produits de l'étape 2";
  }

  if (
    msgLower.includes('byob') &&
    msgLower.includes(
      'tous les produits'
    ) &&
    msgLower.includes('ajouter 2')
  ) {
    return "Continuez à ajouter au moins 2 produits de l'étape 2";
  }

  if (
    msgLower.includes('byob') &&
    msgLower.includes(
      'tous les produits'
    ) &&
    msgLower.includes('ajouter 1')
  ) {
    return "Continuez à ajouter au moins 1 produit de l'étape 2";
  }

  if (
    msgLower.includes(
      'type de coffret'
    )
  ) {
    return "Allez à l'étape 1 et ajoutez votre type de coffret";
  }

  if (
    msgLower.includes('étape 2') &&
    msgLower.includes('ajouter 2')
  ) {
    return (
  'Ajoutez au moins 2 produits dans ' +
  getV2StepName(1) +
  '.'
);
  }

  if (
    msgLower.includes('étape 2') &&
    msgLower.includes('ajouter 1')
  ) {
    return "Continuez à ajouter au moins 1 produit de l'étape 2";
  }

  if (
    msgLower.includes('étape 3') &&
    msgLower.includes('ajouter 2')
  ) {
    return (
  'Ajoutez au moins 2 produits dans ' +
  getV2StepName(2) +
  '.'
);
  }

  if (
    msgLower.includes('étape 3') &&
    msgLower.includes('ajouter 1')
  ) {
    return "Continuez à ajouter au moins 1 produit de l'étape 3";
  }

  if (
    msgLower.includes(
      'carte de souhait'
    ) ||
    msgLower.includes(
      'cartes de souhait'
    ) ||
    msgLower.includes(
      'carte de souhaits'
    ) ||
    msgLower.includes(
      'cartes de souhaits'
    ) ||
    msgLower.includes(
      'cartes de souhaits byob'
    ) ||
    msgLower.includes(
      'carte de souhaits byob'
    )
  ) {
    return "Ajoutez maintenant votre carte de souhait.";
  }

  return "Allez à l'étape 1 et ajoutez votre type de coffret";
}

function updateCartIcon() {
  const cartCount =
    document.querySelector(
      '.cart-count'
    );

  const summary =
    document.getElementById(
      'cuByobCartSummary'
    );

  const finalizeButton =
    document.getElementById(
      'cuByobFinalizeButton'
    );

  const liveButton =
    document.getElementById(
      'cuByobLiveButton'
    );

  const layout =
    document.querySelector(
      '.cu-byob-v2-layout'
    );


  const isMobile =
    window.innerWidth <= 749;


  if (cartCount) {
    cartCount.textContent =
      cartState.totalItems;
  }


  const count =
    cartState.totalItems || 0;


  const productWord =
    count === 1
      ? 'produit'
      : 'produits';


  const realTotal =
    calculateBYOBRealTotal();


  const formattedTotal =
    formatBYOBPrice(
      realTotal
    );


  /* =====================================================
     BOUTON PANIER BYOB
  ===================================================== */

  if (summary) {
    summary.textContent =
      count +
      ' ' +
      productWord +
      ' | ' +
      formattedTotal;
  }


  /* =====================================================
     COFFRET LIVE

     iPhone :
     "Une surprise"

     Autres écrans :
     "Une surprise vous attend"
  ===================================================== */

  if (liveButton) {
    liveButton.textContent =
      isMobile
        ? 'Une surprise'
        : 'Une surprise vous attend';
  }


  /* =====================================================
     BOUTON AJOUTER AU PANIER SHOPIFY
  ===================================================== */

  if (finalizeButton) {

    const requirement =
      typeof buildRequirementState ===
        'function'
        ? buildRequirementState()
        : {
            isComplete: false
          };


        const realValidation =
      validateRealBYOBRequirements();


    if (
      requirement.isComplete &&
      realValidation.isValid
    ) {

      finalizeButton.hidden =
        false;

      finalizeButton.textContent =
        'Ajouter au panier';


      if (layout) {
        layout.classList.add(
          'cu-byob-v2-complete-layout'
        );
      }

    } else {

      finalizeButton.hidden =
        true;


      if (layout) {
        layout.classList.remove(
          'cu-byob-v2-complete-layout'
        );
      }
    }

}

}

function updateCartDisplay() {
  const drawerContent =
    document.getElementById(
      'drawerContent'
    );

  if (!drawerContent) {
    return;
  }

  if (cartState.totalItems === 0) {
    drawerContent.innerHTML = `
      <p class="drawer-progress-msg">
        Votre coffret est prêt à prendre forme.
      </p>
    `;

    return;
  }

  const productThumbnails =
    document.querySelectorAll(
      '.byob-footer-card'
    );

  let productsHTML = '';

  productThumbnails.forEach(
    function(card, index) {
      const img =
        card.querySelector(
          '.byob-footer-thumbnail img'
        );

      const imgSrc =
        img
          ? img.src
          : '';

      const titleEl =
        card.querySelector(
          '.card-title'
        );

      const productTitle =
        titleEl
          ? (
              titleEl.title ||
              titleEl.textContent.trim()
            )
          : (
              'Produit ' +
              (index + 1)
            );

      const detail =
        card.querySelector(
          '.byob-footer-thumbnail-detail'
        );

      const detailDivs =
        detail
          ? Array.from(
              detail.querySelectorAll(
                'div'
              )
            )
          : [];

      const qtyDiv =
        detailDivs.find(
          function(div) {
            return div.textContent
              .trim()
              .startsWith('x');
          }
        );

      const qty =
        qtyDiv
          ? qtyDiv.textContent
              .trim()
              .replace('x', '')
              .trim()
          : '1';

      const productPriceValue =
        getBYOBFooterCardPrice(
          card
        );

      const productPrice =
        productPriceValue > 0
          ? formatBYOBPrice(
              productPriceValue
            )
          : '';

      let collectionName = '';

      const possibleCollectionEl =
        card.querySelector(
          '[data-collection], ' +
          '[data-step], ' +
          '.collection-title, ' +
          '.collection-name'
        );

      if (possibleCollectionEl) {
        collectionName =
          possibleCollectionEl
            .dataset.collection ||
          possibleCollectionEl
            .getAttribute(
              'data-step'
            ) ||
          possibleCollectionEl
            .textContent ||
          '';
      }

      collectionName =
        String(
          collectionName || ''
        )
          .replace(/\s+/g, ' ')
          .trim();

      if (
        !collectionName &&
        card.dataset.cuCollection
      ) {
        collectionName =
          card.dataset.cuCollection;
      }

      if (!collectionName) {
        collectionName =
          'Sélection du coffret';
      }

      productsHTML += `
        <div
          class="drawer-product-item"
          data-index="${index}"
        >

          <button
            class="drawer-remove-btn"
            onclick="removeProductFromDrawer(${index})"
            title="Retirer du coffret"
            aria-label="Retirer ${productTitle} du coffret"
          >
            ✕
          </button>

          <div class="drawer-product-image">
            <img
              src="${imgSrc}"
              alt="${productTitle}"
            >
          </div>

          <div class="drawer-product-info">

            <p class="drawer-product-title">
              ${productTitle}
            </p>

            <p class="drawer-product-collection">
              ${collectionName}
            </p>

            <div class="drawer-product-meta">

              <span class="drawer-product-quantity">
                Qté : ${qty}
              </span>

              ${
                productPrice
                  ? `
                    <span class="drawer-product-price">
                      ${productPrice}
                    </span>
                  `
                  : ''
              }

            </div>

          </div>

        </div>
      `;
    }
  );

  const realTotal =
    calculateBYOBRealTotal();

  const price =
    realTotal > 0
      ? formatBYOBPrice(
          realTotal
        )
      : '';

  const currentMessage =
    typeof getUnifiedCurrentStatusMessage ===
      'function'
      ? getUnifiedCurrentStatusMessage()
      : translateBYOBMessage();

  const requirement =
    typeof buildRequirementState ===
      'function'
      ? buildRequirementState()
      : {
          isComplete: false
        };

  /*
    Grand + moyen :
    le panier ouvert contient
    uniquement les produits.
  */
  let bottomHTML = '';

  drawerContent.innerHTML = `
    <div class="drawer-products">
      ${productsHTML}
    </div>

    ${bottomHTML}
  `;
}

function updateProgressMessage(forcedStepIndex) {
  const messageEl =
    document.getElementById(
      'progressMessage'
    );

  if (!messageEl) {
    return;
  }

  const message =
  getUnifiedCurrentStatusMessage(
    forcedStepIndex
  );

  messageEl.innerHTML = `
    <span class="byob-progress-message-inner">
      ${message}
    </span>
  `;
}

function updateProgressImage() {
  const progressImg =
    document.getElementById(
      'progressImage'
    );

  const giftEl =
    document.querySelector(
      '.byob-injected-gift'
    );

  if (
    !progressImg ||
    !giftEl
  ) {
    return;
  }

  let total = 0;

  document
    .querySelectorAll(
      '.byob-footer-thumbnail-detail div'
    )
    .forEach(d => {
      const text =
        d.textContent.trim();

      if (text.startsWith('x')) {
        const qty =
          parseInt(
            text
              .replace('x', '')
              .trim()
          ) || 0;

        total += qty;
      }
    });

  const photoIndex =
    Math.min(total, 7);

  const imageKey =
    'step' + photoIndex;

  progressImg.src =
    CONFIG.progressImages[
      imageKey
    ];

  let badge =
    giftEl.querySelector(
      '.byob-gift-badge'
    );

  if (total > 7) {
    const extra =
      total - 7;

    if (!badge) {
      badge =
        document.createElement(
          'div'
        );

      badge.className =
        'byob-gift-badge';

      giftEl.appendChild(
        badge
      );
    }

    badge.textContent =
      '+' + extra;
  } else {
    if (badge) {
      badge.remove();
    }
  }
}

function lockBYOBFooterOpen() {
  const beacon =
    document.getElementById(
      'byob-beacon'
    );

  const hideBtn =
    document.getElementById(
      'hide-footer-button'
    );

  [beacon, hideBtn]
    .forEach(el => {
      if (el) {
        el.style.pointerEvents =
          'none';

        el.addEventListener(
          'click',
          e => {
            e.preventDefault();
            e.stopPropagation();
          },
          true
        );
      }
    });

  console.log(
    '🔒 Boutons BYOB verrouillés'
  );
}

function setupEventListeners() {

  document.addEventListener(
    'click',
    function(e) {

      const clickedStep =
        e.target.closest(
          '.circle-step'
        );

      if (!clickedStep) {
        return;
      }

      const steps =
        getV2Steps();

      const clickedStepIndex =
        steps.indexOf(
          clickedStep
        );

      if (
        clickedStepIndex < 0
      ) {
        return;
      }

      cuSelectedStepIndex =
        clickedStepIndex;

      setTimeout(
        function() {
          updateV2StepStates();
          updateProgressMessage();
        },
        180
      );
    },
    true
  );

  document.addEventListener(
    'click',
    function(e) {

      const cartIcon =
        e.target.closest(
          '#byobCartIcon'
        );

      const closeBtn =
        e.target.closest(
          '#closeDrawer'
        );

      const liveButton =
        e.target.closest(
          '#cuByobLiveButton'
        );

      const finalizeButton =
        e.target.closest(
          '#cuByobFinalizeButton'
        );

      const drawer =
        document.getElementById(
          'cartDrawer'
        );

      if (cartIcon) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen =
          drawer?.classList.contains(
            'open'
          );

        setDrawerState(
          !isOpen
        );

        return;
      }

      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();

        setDrawerState(
          false
        );

        return;
      }

      if (finalizeButton) {
        e.preventDefault();
        e.stopPropagation();

        addFinalBundleToCart();

        return;
      }

      if (liveButton) {
  e.preventDefault();
  e.stopPropagation();

  if (
    typeof window.LainohaOpenLibrary ===
    'function'
  ) {
    window.LainohaOpenLibrary();
  }

  return;
}
    }
  );
}

/* =========================================================
   LAINOHA — MÉMOIRE DE CONTINUITÉ BYOB
   VERSION LÉGÈRE — PAR UNIVERS

   OBJECTIF :
   - Conserver l'origine des produits lorsque la cliente
     quitte temporairement son univers BYOB.
   - Restaurer les états nécessaires aux messages au retour.
   - Ne PAS mémoriser les prix : le moteur prix existe déjà.
   - Ne PAS modifier le moteur de messages / popups.
   - Ne PAS scanner les centaines de produits de buildrules.
   - Effacer uniquement la mémoire de CET univers lorsque
     le coffret BYOB a réellement été vidé après finalisation.
========================================================= */

(function initBYOBContinuityMemory() {

  /* =====================================================
     CLÉ UNIQUE DE L'UNIVERS ACTUEL

     Chaque page/univers possède sa propre mémoire.
     Les paramètres ?utm etc. ne sont volontairement
     pas utilisés.
  ===================================================== */

  const universePath =
    String(
      window.location.pathname || '/'
    )
      .replace(/\/+$/, '') || '/';

  const MEMORY_KEY =
    'lainoha_byob_continuity_v1::' +
    universePath;

  const FINALIZE_KEY =
    'lainoha_byob_finalize_pending_v1::' +
    universePath;


  /* =====================================================
     PETITES FONCTIONS UTILITAIRES
  ===================================================== */

  function clearCurrentUniverseMemory() {

    try {
      sessionStorage.removeItem(
        MEMORY_KEY
      );

      sessionStorage.removeItem(
        FINALIZE_KEY
      );
    } catch (error) {
      console.warn(
        '⚠️ Mémoire BYOB : impossible de nettoyer',
        error
      );
    }

    cuProductOriginMemory.clear();

    cuBannerStateMemory = [];

    cuLastCoffretPopupMessage = '';

    console.log(
      '🧹 Mémoire BYOB réinitialisée pour cet univers'
    );
  }


  function saveCurrentUniverseMemory() {

    try {

      const cards =
        Array.from(
          document.querySelectorAll(
            '.byob-footer-card'
          )
        );

      /*
        Si le Tracker est déjà actif et que le panier
        est réellement vide, on ne conserve pas
        d'anciens états.
      */

      if (
        popupMonitorState.initialized &&
        cards.length === 0 &&
        getBYOBTotalItems() === 0
      ) {
        clearCurrentUniverseMemory();
        return;
      }

      /*
        Au chargement d'une page, BYOB peut avoir
        un très court moment où les cartes ne sont
        pas encore rendues.

        On refuse donc d'écraser une bonne mémoire
        avec un panier temporairement vide.
      */

      if (!cards.length) {
        return;
      }


      /*
        On conserve seulement les produits qui existent
        encore réellement dans le panier BYOB.
      */

      const activeKeys =
        new Set(
          cards
            .map(function(card) {
              return getNativeCartCardKey(
                card
              );
            })
            .filter(Boolean)
        );


      const origins = [];

      cuProductOriginMemory.forEach(
        function(value, key) {

          if (
            !key ||
            !value ||
            !activeKeys.has(key)
          ) {
            return;
          }

          origins.push([
            key,
            {
              stepIndex:
                Number.isInteger(
                  value.stepIndex
                )
                  ? value.stepIndex
                  : -1,

              collectionName:
                value.collectionName || ''
            }
          ]);
        }
      );


      /*
        On sauvegarde aussi la petite mémoire d'état
        des étapes.

        IMPORTANT :
        les quantités seront toujours confrontées
        au vrai panier BYOB lors du retour.
      */

      const banners =
        cuBannerStateMemory.map(
          function(state) {

            if (!state) {
              return null;
            }

            return {
              exists:
                !!state.exists,

              selected:
                Number(
                  state.selected || 0
                ),

              minimum:
                Number(
                  state.minimum || 0
                ),

              remaining:
                Number(
                  state.remaining || 0
                ),

              isSatisfied:
                !!state.isSatisfied
            };
          }
        );


      sessionStorage.setItem(
        MEMORY_KEY,
        JSON.stringify({
          version: 1,
          origins: origins,
          banners: banners
        })
      );

    } catch (error) {

      console.warn(
        '⚠️ Mémoire BYOB : sauvegarde impossible',
        error
      );
    }
  }


  function restoreCurrentUniverseMemory() {

    try {

      const raw =
        sessionStorage.getItem(
          MEMORY_KEY
        );

      if (!raw) {
        return false;
      }

      const saved =
        JSON.parse(raw);

      if (
        !saved ||
        saved.version !== 1
      ) {
        return false;
      }


      /* ===== ORIGINE DES PRODUITS ===== */

      cuProductOriginMemory.clear();

      if (
        Array.isArray(
          saved.origins
        )
      ) {
        saved.origins.forEach(
          function(entry) {

            if (
              !Array.isArray(entry) ||
              entry.length < 2 ||
              !entry[0] ||
              !entry[1]
            ) {
              return;
            }

            cuProductOriginMemory.set(
              entry[0],
              {
                stepIndex:
                  Number.isInteger(
                    entry[1].stepIndex
                  )
                    ? entry[1].stepIndex
                    : -1,

                collectionName:
                  entry[1].collectionName ||
                  ''
              }
            );
          }
        );
      }


      /* ===== ÉTATS DES COLLECTIONS ===== */

      if (
        Array.isArray(
          saved.banners
        )
      ) {
        cuBannerStateMemory =
          saved.banners.map(
            function(state) {

              if (!state) {
                return undefined;
              }

              return {
                exists:
                  !!state.exists,

                selected:
                  Number(
                    state.selected || 0
                  ),

                minimum:
                  Number(
                    state.minimum || 0
                  ),

                remaining:
                  Number(
                    state.remaining || 0
                  ),

                isSatisfied:
                  !!state.isSatisfied
              };
            }
          );
      }


      console.log(
        '💾 Mémoire BYOB restaurée pour cet univers :',
        cuProductOriginMemory.size,
        'produits connus'
      );

      return true;

    } catch (error) {

      console.warn(
        '⚠️ Mémoire BYOB : restauration impossible',
        error
      );

      return false;
    }
  }


  /* =====================================================
     1. RESTAURATION AVANT LE DÉMARRAGE DU MONITEUR

     On enveloppe simplement la fonction existante.
     Son fonctionnement interne reste inchangé.
  ===================================================== */

  const originalStartPopupMonitoring =
    startPopupMonitoring;

  startPopupMonitoring =
    function() {

      restoreCurrentUniverseMemory();

      /*
        On remet immédiatement les informations connues
        sur les cartes déjà restaurées par BYOB.
      */

      applyKnownProductOrigins();

      originalStartPopupMonitoring();


      /*
        Une fois BYOB complètement stabilisé,
        on confronte la mémoire au VRAI panier actuel.
      */

      setTimeout(
        function() {

          applyKnownProductOrigins();

          const snapshot =
            captureNativeCartSnapshot();

          syncBannerStateMemoryFromCartSnapshot(
            snapshot
          );

          updateV2StepStates();

          updateProgressMessage(
            cuSelectedStepIndex
          );

          updateCartIcon();
          updateCartDisplay();

          saveCurrentUniverseMemory();

        },
        900
      );


      /*
        CAS PARTICULIER :
        la cliente avait cliqué "Ajouter au panier"
        avant de quitter la page.

        Si BYOB revient réellement vide,
        la finalisation a réussi :
        on efface CET univers seulement.

        Si des produits sont encore présents,
        l'ajout n'a pas vidé BYOB et on conserve tout.
      */

      setTimeout(
        function() {

          const finalizePending =
            sessionStorage.getItem(
              FINALIZE_KEY
            ) === '1';

          if (!finalizePending) {
            return;
          }

          if (
            getBYOBTotalItems() === 0
          ) {
            clearCurrentUniverseMemory();

            updateV2StepStates();

            updateProgressMessage(0);

            updateCartIcon();
            updateCartDisplay();

          } else {

            /*
              Les produits existent encore :
              aucune finalisation confirmée.
            */

            sessionStorage.removeItem(
              FINALIZE_KEY
            );
          }

        },
        1500
      );
    };


  /* =====================================================
     2. SAUVEGARDE IMMÉDIATE LORS D'UN AJOUT

     La fonction originale continue à déterminer
     collection + stepIndex exactement comme avant.
  ===================================================== */

  const originalRememberAddedProductOrigins =
    rememberAddedProductOrigins;

  rememberAddedProductOrigins =
    function(
      previousSnapshot,
      currentStepIndex
    ) {

      originalRememberAddedProductOrigins(
        previousSnapshot,
        currentStepIndex
      );

      saveCurrentUniverseMemory();
    };


  /* =====================================================
     3. SAUVEGARDE APRÈS RECALCUL DES ÉTAPES

     captureAllBannerStates() est déjà appelée par
     ton moteur lorsqu'un changement est stabilisé.

     Aucun nouveau polling n'est ajouté.
  ===================================================== */

  const originalCaptureAllBannerStates =
    captureAllBannerStates;

  captureAllBannerStates =
    function() {

      const states =
        originalCaptureAllBannerStates();

      saveCurrentUniverseMemory();

      return states;
    };


  /* =====================================================
     4. FINALISATION DU COFFRET

     IMPORTANT :
     on NE SUPPRIME PAS immédiatement la mémoire.

     On inscrit seulement "finalisation en attente".

     La mémoire sera supprimée uniquement si le panier
     BYOB devient réellement vide.

     Donc :
     - rupture de stock = mémoire conservée
     - erreur Shopify = mémoire conservée
     - ajout réussi = mémoire supprimée
  ===================================================== */

    const originalAddFinalBundleToCart =
    addFinalBundleToCart;


  addFinalBundleToCart =
    function() {

      /*
        On mémorise d'abord si le coffret
        contenait réellement des produits.
      */

      const hadItemsBefore =
        getBYOBTotalItems() > 0;


      /*
        IMPORTANT :

        La fonction originale possède maintenant
        notre validation de sécurité.

        Elle retourne :
        - false = finalisation refusée
        - true  = clic natif BYOB réellement lancé
      */

      const finalizationStarted =
        originalAddFinalBundleToCart();


      /*
        Coffret incomplet ou bouton BYOB absent :
        surtout ne PAS créer un indicateur
        "finalisation en attente".
      */

      if (!finalizationStarted) {

        try {
          sessionStorage.removeItem(
            FINALIZE_KEY
          );
        } catch (error) {
          console.warn(
            '⚠️ Mémoire BYOB : impossible de nettoyer l’indicateur de finalisation',
            error
          );
        }

        return false;
      }


      /*
        Seulement ici :
        la validation est passée ET le bouton BYOB
        a réellement été déclenché.
      */

      try {

        sessionStorage.setItem(
          FINALIZE_KEY,
          '1'
        );

      } catch (error) {

        console.warn(
          '⚠️ Mémoire BYOB : indicateur de finalisation impossible',
          error
        );
      }


      if (!hadItemsBefore) {
        return true;
      }


      /*
        Si BYOB a vidé le panier immédiatement,
        la finalisation est déjà confirmée.
      */

      if (
        getBYOBTotalItems() === 0
      ) {

        clearCurrentUniverseMemory();

        return true;
      }


      /*
        Petit observateur TEMPORAIRE.

        Exactement le même principe qu'avant :
        on attend que BYOB vide réellement
        son panier avant d'effacer la mémoire.
      */

      const target =
        document.querySelector(
          '.byob-footer'
        ) ||
        document.body;


      let observerStopped =
        false;


      const stopObserver =
        function() {

          if (observerStopped) {
            return;
          }

          observerStopped =
            true;

          finalizeObserver.disconnect();
        };


      const finalizeObserver =
        new MutationObserver(
          function() {

            if (
              getBYOBTotalItems() !== 0
            ) {
              return;
            }


            clearCurrentUniverseMemory();

            stopObserver();
          }
        );


      finalizeObserver.observe(
        target,
        {
          childList:
            true,

          subtree:
            true,

          characterData:
            true
        }
      );


      /*
        Même sécurité qu'avant :
        l'observateur temporaire disparaît
        après 12 secondes.
      */

      setTimeout(
        stopObserver,
        12000
      );


      return true;
    };


  console.log(
    '✅ Mémoire de continuité BYOB activée'
  );

})();

if (
  document.readyState ===
  'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    init
  );
} else {
  init();
}

})();

function removeProductFromDrawer(index) {
  const footer =
    document.querySelector(
      '.byob-footer'
    );

  if (!footer) return;

  const removeIcons =
    footer.querySelectorAll(
      '.byob-footer-remove-icon'
    );

  if (removeIcons[index]) {
    removeIcons[
      index
    ].parentElement.click();

    console.log(
      '🗑️ Produit supprimé:',
      index
    );
  } else {
    console.warn(
      '⚠️ Icône non trouvée pour index:',
      index
    );
  }
}

window.removeProductFromDrawer =
  removeProductFromDrawer;